/* NarrowPath theme JS — no dependencies */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* ROUND 65 (backlog 27): the trailing `.replace(/\.00$/,'')` rendered `$69` while
     Liquid's `money` filter renders `$69.00`, so the drawer and /cart showed the SAME
     cart in two different money formats. Money is never abbreviated on a checkout
     surface — always two decimals, so every price on the site agrees. */
  var money = function (c) {
    return '$' + (c / 100).toFixed(2);
  };

  /* ---- sticky header ---- */
  var hdr = $('.hdr');

  /* ---- the phone/tablet purchase affordance (ROUND 150, axis 3) -------------
     `.sticky-buy` is the fixed bottom bar carrying the plan name, the price and
     a "Choose plan" button. np.css:1473 shows it only at <=960px, because above
     that width `.buy-media{position:sticky;top:100px}` keeps the buy column in
     view instead. So this bar IS the phone's entire buy rail.

     It shipped gated on a bare `window.scrollY > 1400`. Measured on the live
     draft with tools/pdp_proof_fold_probe.py --mode buybar (50px steps, whole
     document), BEFORE this change:

       390x844   real submit button first enters the viewport at scrollY 1250.
                 The bar first paints at scrollY 1500.
                 BLIND RUN scrollY 0 -> 1200 = 1250px = 1.48 viewport heights
                 with NO price and NO buy control on screen at any moment.
                 Then 650px where the bar is shown ON TOP of the real button.
       744x1133  real button at 900, bar at 1600. Blind 0 -> 850 = 900px.
                 Redundant 500px.

     The constant was not merely too big - it was INVERTED. It hid the substitute
     during the entire stretch the real control is missing, and showed it during
     the stretch the real control is already on screen, where its only effect is
     to cover ~66px of the bottom of the fold.

     Root cause is that 1400 is a page-agnostic number driving a page-dependent
     affordance. `sections/np-buybox.liquid` renders on BOTH templates, and the
     geometry is nothing alike: on `templates/product.json` the buy box is the
     FIRST section (`#buy` top = 109px at 390), on `templates/index.json` it is
     the sixth. One scroll constant cannot be right for both, and it was right
     for neither.

     The rule below is derived from the page rather than fitted to it, and it is
     stated as the bar's actual job: BE THERE WHEN NOTHING ELSE ON SCREEN CAN
     TAKE THE ORDER, AND GET OUT OF THE WAY WHEN SOMETHING CAN.

       show  <=>  no purchase affordance is currently inside the viewport

     A "purchase affordance" is defined by FUNCTION, not by section name, so the
     set does not go stale when a section is renamed or reordered:
       - `[data-buy-submit]`                          the buy box's real submit
       - `form[action="/cart/add"] button[type=submit]` the shop grid's add buttons
       - `a.btn[href="#buy"]`                          every CTA that jumps to it
       - `a.btn[href^="/cart"]`                        anything going to the bag
     The bar's OWN "Choose plan" button matches that last-but-one pattern, so it
     is filtered out by `sbBar.contains()`. Without that filter the predicate
     cancels itself: bar shows -> its own button is on screen -> bar hides.

     Measured on the live draft at 390x844 with the same probe, AFTER:
       PDP   blind 1250px -> 100px (0.66% of stops), redundant 650px -> 100px.
             Both residuals are the bar's own 0.32s transform transition caught
             mid-flight by a 40ms sampling settle - the class flips at the right
             stop and the rect catches up two stops later. That is an animation
             in progress, not a gap. Do NOT delete the transition to make a
             probe read zero.
       744x1133 blind 900px -> 0px.
       1440x900 UNCHANGED and must stay unchanged: np.css:1473 only displays the
             bar at <=960px, because above that `.buy-media`'s own sticky rail
             carries the buy column. It is this round's control.
       HOME  the bar now leaves the hero alone (the hero's own CTA is on screen
             through the first 369px) instead of appearing at a blind 1400.

     `1400` survives ONLY as the fallback for a page that renders no affordance
     at all, so no template can lose behaviour it had. Do not replace this with a
     scroll constant again. */
  var SB_AFFORDANCE = '[data-buy-submit], form[action="/cart/add"] button[type=submit],' +
                      ' a.btn[href="#buy"], a.btn[href^="/cart"]';
  var sbBar = $('.sticky-buy');
  var sbTargets = $$(SB_AFFORDANCE).filter(function (e) {
    return !(sbBar && sbBar.contains(e));
  });

  /* ---- ROUND 253, AXIS 5, BACKLOG 288: THE FLICKER IS A CENSUS PROBLEM, NOT A
     CONSTANT PROBLEM, AND THIS IS THE LAYOUT-LEVEL ANSWER ROUND 249 SAID WAS OWED.

     Round 249 measured the bar changing state ELEVEN times on ONE mobile scroll of
     the home page (125 stops every 150px down 19,550px) - the defect Jared reported
     himself on 2026-08-20, "the follow your path button is disappearing and
     reappearing" - and PROVED BY SIMULATION that no lookahead constant closes it
     (560 / 0 / asymmetric all give 11). Its own conclusion, written into this file:
     "the count is a function of how many purchase affordances this page scatters
     down 19,550px". So the fix has to change WHICH NODES COUNT, not by how much.

     Re-measured live on the published page this round
     (captures/round-253/stickybuy-before.json): SIX affordances, at document y538,
     y3066, y6539, y10562, y14843, y17960. FIVE of the six are `a.btn[href="#buy"]`
     - in-page JUMP LINKS whose entire function is to deliver the visitor to the
     sixth one, the real `[data-buy-submit]` in the buy box at y6539. The bar was
     therefore retracting in favour of a control that does exactly what the bar
     itself does: scroll you to the buy box. That is the predicate cancelling itself
     at a distance - the same class of bug the `sbBar.contains(e)` filter fixed at
     zero distance - and it is the whole of the flicker.

     THE RULE: the bar defers to a control that can actually TRANSACT (a real submit),
     and to any affordance sitting in the FIRST SCREENFUL (the hero's own CTA, where
     a floating duplicate is noise and where round 233 deliberately made the bar leave
     the hero alone). It no longer defers to a jump link 10,000px down the page.

     SIMULATED AGAINST THE SAME LIVE 125-STOP TRACE BEFORE A LINE WAS WRITTEN
     (captures/round-253/stickybuy-sim253.json):
       current (all six)        : 11 transitions, 70.4% of stops shown
       submit only              :  3 transitions, 95.2% - but SHOWS AT y0, i.e. it
                                   floats a duplicate bar over the fold on first
                                   paint. Rejected; that regresses round 233.
       submit + above-the-fold  :  3 transitions, 91.2%  <- SHIPPED
       + the final CTA too      :  5 transitions, 85.6%. Rejected: two extra
                                   disappearances bought nothing measurable.
     Hidden windows go from six (600-1350px wide) to ONE 900px window sitting
     directly over the buy box, which is the only place a floating duplicate is
     genuinely redundant.

     ONE-DIRECTIONAL, PROVED not assumed: replayed stop by stop, there is NO stop
     where the old rule showed the bar and this one hides it (empty violation list),
     and 26 stops gain it. So this cannot open a blind spot and cannot regress the
     2026-08-20 corridor fix, which stays intact in the asymmetric lookahead below.

     FALLBACK, so no other template can lose behaviour it has: if a page renders no
     transacting control and no above-fold affordance, `sbBlocking` comes back empty
     and every target blocks exactly as before. Only pages that HAVE a real submit
     change. */
  var sbIsSubmit = function (e) {
    return e.hasAttribute('data-buy-submit') ||
           (e.tagName === 'BUTTON' && e.type === 'submit' && e.closest('form[action="/cart/add"]'));
  };
  var sbBlocking = sbTargets.filter(function (e) {
    if (sbIsSubmit(e)) return true;
    var r = e.getBoundingClientRect();
    return (r.top + window.scrollY) < window.innerHeight;   /* the hero's own CTA */
  });
  if (!sbBlocking.length) sbBlocking = sbTargets;
  if (sbBar) sbBar.setAttribute('data-sb', 'r253-census');
  var stickyBuyWanted = function () {
    if (!sbBar) return false;
    if (!sbBlocking.length) return window.scrollY > 1400;
    /* +560px lookahead below the fold (2026-08-20 PM2): an affordance about to arrive
       counts as arrived. Between the scrollstats payoff CTA leaving the screen and the
       buybox submit entering it there is a ~700px corridor with no purchase control -
       measured live at 390x844 (payoff CTA clears ~y3900, submit tops in at y5625). At
       any scroll speed that corridor gave the bar a brief cameo (slide in, slide out) on
       top of the clean hide it already did at the payoff - Jared read the sum of these
       as "disappearing and reappearing". 560 bridges that corridor completely in both
       directions, at the price of the bar retracting up to ~0.6 viewport before each
       REAL control arrives - a calm early exit, not a blind spot: the control the bar
       hands off to is on screen within one flick. */
    /* ROUND 249, AXIS 5 - THE LOOKAHEAD IS NOW ASYMMETRIC, AND THE HONEST REASON IS
       NARROWER THAN IT LOOKS. This round measured the predicate itself on the LIVE
       published page at 390x844, every 150px down the whole 19,550px home document
       (125 stops, captures/round-249-after/stickybuy-sim.json). Result: the bar changes
       state ELEVEN times on one scroll of the home page - six shown windows and six
       hidden ones, the hidden ones 600-1350px wide. That is a real, measured, still-open
       axis-5 defect and it is why axis 5 scores 8 this round instead of inheriting 9.

       This edit does NOT fix it. Simulated both ways against that same 125-stop trace
       before writing a line: look=560 gives 11 transitions, look=0 gives 11 transitions,
       and the asymmetric rule below gives 11 transitions. The transition COUNT is set by
       how many purchase affordances this page scatters down 19,550px, not by the
       lookahead, and no constant in this function can change that. Do not let a future
       round re-derive the same lookahead tweak believing it will.

       What it DOES do, measured, is the reason it ships anyway:
         - the one genuinely sub-viewport cameo, a 300px shown window at y4800-5100
           between two hidden ones, widens to 750px. At a hard fling (~1.7px/ms) that
           is a ~176ms blink becoming a ~440ms presence - past the 0.32s slide, so the
           bar finishes arriving before it is asked to leave.
         - the bar's share of the page rises from 59.2% to 70.4%.
       Both are strictly one-directional: the bar is only ever shown MORE, never less,
       so this cannot open a blind spot and cannot regress the 2026-08-20 corridor fix.

       The rule: when the bar is HIDDEN keep the full +560 lookahead, so an affordance
       about to arrive still counts as arrived and the bar does not bother appearing in
       front of it (that is exactly the 2026-08-20 PM2 corridor fix, preserved intact).
       When the bar is SHOWN, drop the lookahead to 0 and retract only for a control
       that is GENUINELY on screen - the "calm early exit" was costing up to 0.66 of a
       viewport of presence before every real control, for no measured gain. */
    var vh = window.innerHeight + (sbShown ? 0 : 560);
    for (var i = 0; i < sbBlocking.length; i++) {
      var r = sbBlocking[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0 && r.top < vh) {
        /* 2026-08-20 PM2 (Jared's screen recording: "the follow your path button is
           disappearing and reappearing"): an affordance that CANNOT take a click is not
           an affordance. The scrollstats payoff CTA sits at top:90vh inside the pinned
           stage with opacity:0 + pointer-events:none for most of a ~2,000px pin, yet its
           rect passed this test the whole time - so the bar vanished for the entire
           formula section and re-toggled at both pin boundaries and again mid-payoff as
           the CTA faded. Rule stays functional, not name-based: clickable, or absent. */
        if (getComputedStyle(sbBlocking[i]).pointerEvents === 'none') continue;
        return false;
      }
    }
    return true;
  };

  /* 2026-08-20 PM2 - hysteresis. The class used to flip on EVERY raw scroll event with
     zero damping, so any oscillation of the show/hide boundary - and iOS resizes the
     viewport (moving that boundary) on essentially every change of scroll direction when
     the browser chrome collapses/expands - caught the bar's own 0.32s slide mid-flight
     and read as flicker. HIDE is still instant (never cover a real buy control), but
     SHOW now requires the "nothing can take the order" state to hold for 400ms straight
     (400 and not less: a hard fling moves ~1.7px/ms, so a shorter dwell still let the
     bar blip in and straight back out while crossing the gap between two CTA zones).
     A boundary wobble therefore produces at most one clean hide, never an in-out-in. */
  var sbShown = false, sbT = 0;
  var sbApply = function () {
    var want = stickyBuyWanted();
    if (want === sbShown) { if (sbT) { clearTimeout(sbT); sbT = 0; } return; }
    if (!want) {
      if (sbT) { clearTimeout(sbT); sbT = 0; }
      sbShown = false; sbBar.classList.remove('show');
      /* round 253: one class, one truth. `html.sb-on` mirrors `.sticky-buy.show`
         exactly so layout that must clear the bar (the scrollstats payoff CTA at
         90vh, which this round's census change put directly behind it) reads the
         bar's real state instead of guessing at a media query. */
      document.documentElement.classList.remove('sb-on');
    } else if (!sbT) {
      sbT = setTimeout(function () {
        sbT = 0;
        if (stickyBuyWanted() && !sbShown) {
          sbShown = true; sbBar.classList.add('show');
          document.documentElement.classList.add('sb-on');
        }
      }, 400);
    }
  };

  /* ---- header transparent-fade over dark sections (backlog 265, Jared 2026-08-23
     12:10 PM PT: "Transparent fade" — the cream sticky header was slabbing a solid
     light bar across every navy (--deep #2F3F5E) section as the page scrolled under
     it. Fix: .hdr.on-dark drops the header to fully transparent + inverts its ink to
     white whenever the header's own box overlaps a dark full-bleed section
     (.band-deep: pathway/patterns/easy/ridiculous, plus the footer .ftr on
     --deep-900); .hdr.stuck (opaque cream) still owns every other position.

     Deliberately NOT a second IntersectionObserver. Round 75 (a few hundred lines
     up in this same file) documented, with measurements, that a bare IO misses
     containers entirely on a fast scroll/fling because it only samples frames it
     actually gets — exactly the failure mode a header color state can't afford (a
     missed toggle means white-on-white or navy-on-navy text). Reusing the SAME
     rAF-throttled getBoundingClientRect approach `stickyBuyWanted()` already uses
     a few lines up keeps this correct every frame instead of eventually-consistent,
     and costs nothing extra since it rides the same scroll handler and the same
     rAF budget as .hdr.stuck. */
  var darkTargets = $$('.band-deep, .ftr');
  var hdrOverlapsDark = function () {
    if (!hdr || !darkTargets.length) return false;
    var hh = hdr.getBoundingClientRect().height || 75;
    for (var i = 0; i < darkTargets.length; i++) {
      var r = darkTargets[i].getBoundingClientRect();
      /* header box is the fixed [0, hh] band at the top of the viewport - "on dark"
         means a dark section's box actually reaches into that band, not merely
         that it exists somewhere on the page. */
      if (r.height > 0 && r.top < hh && r.bottom > 0) return true;
    }
    return false;
  };

  /* rAF-throttled (was raw): the handler does layout reads (rects) after a class write,
     and unthrottled it ran several times per frame on mobile - see the PM2 jank pass. */
  var scrRaf = 0;
  var onScroll = function () {
    if (scrRaf) return;
    scrRaf = requestAnimationFrame(function () {
      scrRaf = 0;
      if (hdr) {
        hdr.classList.toggle('stuck', window.scrollY > 8);
        hdr.classList.toggle('on-dark', hdrOverlapsDark());
      }
      if (sbBar) sbApply();
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* ---- reveal on scroll ----
     ROUND 75 (backlog 44, and much more than backlog 44).

     The bug: this was a bare one-shot IntersectionObserver. IO only reports on
     frames it actually samples, so ANY scroll that moves further than a
     container's on-screen window between two samples skips that container
     forever - it is unobserved-on-intersect, so a missed element is never
     looked at again and stays at `opacity:0` for the life of the page load.

     Measured live at 390x844 on the real draft theme before a byte was touched:

       700px steps  ->  0 of 29 containers stuck   (what capture.py does, which
                                                    is why 74 rounds read clean)
       2000px steps -> 11 of 29 stuck
       5000px steps -> 24 of 29 stuck   - the shop grid, the buy box, the
                                          patterns rail, reviews, FAQ and the
                                          final CTA, all permanently invisible

     A phone fling covers 3000-6000px. So does an in-page anchor jump, and so
     does the browser restoring scroll position on a reload. Round 74 found ONE
     212px heading blank and wrote it up as a heading bug; it is the observer,
     and it can blank most of the page.

     The fix is a catch-up sweep, not a bigger threshold and not
     `opacity:1!important` on a selector. `passed()` recomputes the SAME
     condition IO was asked for (8% of the box inside the viewport, less the
     40px bottom margin) on demand, plus one rule IO cannot express: if a
     container's bottom is already above the viewport top, the visitor has
     scrolled past it and it must never still be blank. The sweep runs
     rAF-throttled off the scroll it already listens to, on resize, and ONCE
     immediately - that last call is what fixes reload-at-depth, where every
     container above the restored position would otherwise stay hidden.

     IO is kept rather than replaced: it still handles reveals that happen with
     no scroll event at all (late web fonts, the Judge.me widget landing, any
     content that grows under a container). The two systems share `reveal()` and
     the same pending list, so neither can double-fire. */
  if ('IntersectionObserver' in window) {
    var rvPending = $$('.rv');
    var reveal = function (el) {
      var i = rvPending.indexOf(el);
      if (i > -1) rvPending.splice(i, 1);
      if (el.classList.contains('in')) return;
      el.classList.add('in');
      io.unobserve(el);
    };
    /* ROUND 158 (backlog 131) — THE 8% IS A FRACTION OF THE ELEMENT'S OWN
       HEIGHT, SO THE TALLER A CONTAINER IS THE HARDER IT IS TO REVEAL.

       That is backwards, and on the phone PDP it blanked the entire buy column
       at rest. `[data-buybox]` holds the proofline, the headline, the lede, the
       tick claims, the plan selector and the CTA — every product word on the
       page — and it is the tallest container on the build. Measured on the
       unfixed draft at scrollY 0, `cls:"rv" hasIn:false opacity:"0"`:

         viewport    top      height    needs 8%   visible   short by
         m360x780    669.47   2133.31   170.66      70.53     100.13
         m390x844    709.47   1984.67   158.77      94.53      64.24
         m414x896    741.47   1865.09   149.21     114.53      34.68
         w1440x900   212.59   1722.46   137.80     647.41     fires

       Desktop cleared it and every phone missed it, which is exactly the split
       a percentage-of-own-height rule produces. Round 150 filed this as
       "709.47px before the first product word" (backlog 131) — but 709.47 is a
       rect on an element painting at opacity 0, so the honest statement was
       never "the word is far down", it was "the word is not painted".

       The floor, derived and not fitted: it has to clear the binding case,
       m360's 70.53px, and it must not disturb anything that already reveals
       correctly. `Math.min` is the identity for every element shorter than
       48/0.08 = 600px, so only containers taller than 600px change at all, and
       for those the percentage was the wrong instrument in the first place.
       320x568 is deliberately out of reach: there the buybox's top sits below
       the reveal line at rest, no constant can paint it, and the visitor
       scrolling is the correct answer.

       Do NOT re-derive this as a bigger `threshold`, and do NOT raise it to a
       percentage again — a percentage is the bug. */
    var RV_MIN_PX = 48;
    /* Same arithmetic IO was given, evaluated against wherever we are NOW. */
    var passed = function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom <= 0) return true;                 /* scrolled clean past it */
      var line = window.innerHeight - 40;             /* the rootMargin bottom */
      var vis = Math.min(r.bottom, line) - Math.max(r.top, 0);
      if (vis <= 0) return false;
      if (r.height === 0) return true;
      return vis >= Math.min(0.08 * r.height, RV_MIN_PX);
    };
    /* `threshold: [0, 0.08]` is STRICTLY ADDITIVE. 0.08 is kept so every
       element's existing firing point is preserved exactly; the extra 0 sample
       only gives a tall container an earlier opportunity, and the callback now
       applies `passed()` so IO and the sweep genuinely share one rule. The
       round-75 comment below already claimed they did — that claim was false
       for tall elements, and that gap is where this bug lived. */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && passed(e.target)) reveal(e.target); });
    }, { threshold: [0, 0.08], rootMargin: '0px 0px -40px' });
    var rvQueued = false;
    var rvSweep = function () {
      rvQueued = false;
      for (var i = rvPending.length - 1; i >= 0; i--) {
        if (passed(rvPending[i])) reveal(rvPending[i]);
      }
    };
    var rvTick = function () {
      if (rvQueued || !rvPending.length) return;
      rvQueued = true;
      window.requestAnimationFrame(rvSweep);
    };
    rvPending.forEach(function (el) { io.observe(el); });
    window.addEventListener('scroll', rvTick, { passive: true });
    window.addEventListener('resize', rvTick, { passive: true });
    /* The first sweep waits for `load`, it does NOT run inline. Running it
       during parse would add `.in` before the first paint, so the hero's
       containers would paint already-opaque and lose their entrance transition
       entirely - trading a reveal bug for a motion regression on axis 5. By
       `load`, IO has delivered its own initial batch (fold elements animate in
       exactly as before) and any restored scroll position has settled, which is
       the case this call exists for. */
    if (document.readyState === 'complete') { setTimeout(rvTick, 0); }
    else { window.addEventListener('load', function () { setTimeout(rvTick, 0); }); }
    /* ROUND 166 (backlog 156) — TELL THE LAYOUT'S WATCHDOG THE REVEAL SYSTEM IS
       LIVE. Written HERE, after IO is constructed and every `.rv` is observed
       and both listeners are attached — not at the top of the file. A script
       that throws after its first few statements has not revealed anything, and
       a flag set early would tell the watchdog to stand down for a system that
       does not exist. The watchdog reads this on DOMContentLoaded; `defer`
       guarantees this line has run by then, or that this file never ran at all.
       CONTRACT: do not hoist this, and do not delete it — deleting it makes the
       watchdog fire on every healthy page load, which is an axis-5 regression. */
    document.documentElement.classList.add('rv-live');
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('in'); });
    document.documentElement.classList.add('rv-live');
  }

  /* ---- mobile nav ---- */
  var mnav = $('.mnav');
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mnav-open]');
    var c = e.target.closest('[data-mnav-close]');
    if (o && mnav) { mnav.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (c && mnav) { mnav.classList.remove('open'); document.body.style.overflow = ''; }
  });

  /* ---- accordions ----
     ROUND 195, axis 3, backlog 126. THIS IS NO LONGER THE THING THAT OPENS AN ACCORDION.

     It used to be. `.acc-item` was a <div> and `.acc-q` a <button>, and the ONLY way an answer
     ever opened was this handler writing an inline style.maxHeight. Measured before the fix
     (captures/round-195-acc-nojs.json): with np.js blocked, clicking a question opened
     0 of the 11 objection answers on the home page — the 30-day guarantee, the cancel terms,
     the medication warning and the whole price justification, all unreadable. That is the same
     failure class rounds 166 and 168 fixed for the buy path, never once pointed at the
     objection surface.

     `.acc-item` is now a <details> and `.acc-q` a <summary>. The BROWSER opens it, with no
     script, and np.css drives the slide off `[open]`. This handler is now PURE PROGRESSIVE
     ENHANCEMENT and does exactly one thing: keeps a group single-open. If it never runs, the
     accordion still works — items just open independently, which is a fine no-JS state.

     DO NOT re-add inline style.maxHeight writes here. They would fight the CSS cap and
     re-couple opening to this script, which is the defect this round removed.

     `toggle` does not bubble, hence the capture-phase listener. `accBusy` guards the
     close-others loop from re-entering through the toggles it fires itself. Named `accBusy`
     and not `busy` on purpose — round 194 lost two pushes to a `var` shadow in this file
     (backlog 206), so every driver-level name in here is now grepped before it is used. */
  var accBusy = false;
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item || !item.classList || !item.classList.contains('acc-item')) return;
    if (!item.open || accBusy) return;
    var group = item.closest('.acc');
    if (!group || group.dataset.single === 'false') return;
    accBusy = true;
    $$('.acc-item[open]', group).forEach(function (i) { if (i !== item) i.open = false; });
    accBusy = false;
  }, true);

  /* ---- plan selector ---- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('.plan');
    if (!p) return;
    var box = p.closest('[data-buybox]');
    if (!box) return;
    $$('.plan', box).forEach(function (x) { x.classList.remove('sel'); });
    p.classList.add('sel');
    /* ROUND 65: the `np-plan` hidden input this used to write was removed from
       np-buybox.liquid — it rode every /cart/add.js POST with an empty value and
       nothing on either side ever read it. The three fields that actually carry the
       plan are `id` (data-plan-id), `properties[Plan]` (data-plan-prop) and
       `selling_plan` (data-plan-sp), all written below. */
    var vid = $('input[data-plan-id]', box);
    if (vid && p.dataset.vid) vid.value = p.dataset.vid;
    var prop = $('input[data-plan-prop]', box);
    if (prop) prop.value = p.dataset.plan || '';
    var spi = $('input[data-plan-sp]', box);
    if (spi) spi.value = p.dataset.sp || '';
    var btn = $('[data-buy-submit]', box);
    if (btn && p.dataset.cta) btn.textContent = p.dataset.cta;
    var sb = $('.sticky-buy b');
    if (sb && p.dataset.stickylabel) sb.textContent = p.dataset.stickylabel;
    var sp = $('.sticky-buy small');
    if (sp && p.dataset.stickyprice) sp.textContent = p.dataset.stickyprice;
    /* ROUND 160 (axis 3): the head price (.bhp, in .buy-head above the media
       well) is the SAME fact as the sticky bar's rest state, so it is written
       from the SAME two datasets rather than from a second source of truth —
       a head price and a sticky price that can disagree is worse than no head
       price at all. `data-headprice-*` is queried at document scope on purpose:
       .buy-head is a SIBLING of [data-buybox], not a descendant, so the `box`
       scope used above cannot see it (round 150 lost a run to exactly this
       sibling-vs-descendant mistake with .sticky-buy). */
    var hp = $('[data-headprice-price]');
    if (hp && p.dataset.stickyprice) hp.textContent = p.dataset.stickyprice;
    var hl = $('[data-headprice-plan]');
    if (hl && p.dataset.stickylabel) hl.textContent = p.dataset.stickylabel;
  });

  /* ---- cart drawer ------------------------------------------------------
     ROUND 64. Three real defects lived in this block for 63 rounds, all of
     them found by finally EXECUTING an add-to-cart instead of reading the
     form's FormData and reporting what it would post:

     1. The rendered line said "Subscribe & Save · Qty 1 · $69" and nothing
        else. The line item carries a selling plan - the visitor has just
        started a RECURRING charge - and the bag never said so. That is the
        single most important fact on the screen and it was missing.
     2. There was no quantity control and no remove. Wrong thing in the bag,
        and the only exit was the browser back button.
     3. The lock was `document.body.style.overflow='hidden'`. That is the same
        idiom round 57 proved makes <body> a scroll container, and round 63
        replaced with a ROOT lock for exactly this reason. Ported here.
     Plus a11y: the closed drawer kept its Checkout link in the tab order.  */
  var drawer = $('.drawer'), scrim = $('.scrim'), lastOpener = null;
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('open');
    document.documentElement.classList.add('np-lock');
    var x = drawer.querySelector('[data-cart-close]');
    if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('open');
    document.documentElement.classList.remove('np-lock');
    if (lastOpener && document.contains(lastOpener)) { try { lastOpener.focus(); } catch (err) {} }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    /* ---- ROUND 241, backlog 282 - THE BAG BUTTON THAT DID NOTHING ----
       OBSERVED LIVE this round, not theorised: while verifying backlog 281 on
       www.npgummy.com the storefront started answering /cart.js with HTTP 429
       and an HTML challenge page (the same bot challenge backlog 160 already
       records on /cart). renderCart() calls r.json() on that HTML, the parse
       throws, the promise REJECTS - and this line had no .catch, so
       openDrawer() simply never ran. Clicking the bag icon did nothing at
       all: no drawer, no error, no navigation, nothing in the console that a
       visitor would ever see. A dead cart button on a storefront is total
       loss of the funnel, and it failed SILENTLY, which is why no capture and
       no score in 240 rounds ever caught it.
       The click now always gets an answer. If the bag could not be read we
       still open the drawer and say so honestly, with a real link to /cart
       that works with this script dead - the same "the markup works without
       the JS" contract the rest of this file already keeps. It never invents
       an empty bag, because "Your bag is empty" and "we could not read your
       bag" are different facts and only one of them is true. */
    if (o) {
      e.preventDefault(); lastOpener = o;
      renderCart().then(openDrawer).catch(function () {
        var body = $('.drawer-body');
        if (body && !body.querySelector('.ci')) {
          body.innerHTML = '<div class="drawer-empty"><b>We could not load your bag just now.</b>' +
            '<p>Nothing was lost - it is still there. Open the full cart page and it will show up.</p>' +
            '<a class="btn" href="/cart">Open my cart</a></div>';
        }
        var ft = $('.drawer-ft');
        if (ft) ft.style.display = '';
        openDrawer();
      });
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('.scrim')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      if (mnav) mnav.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  /* ---- ROUND 233, backlog 276 - THE DRAWER'S ORPHAN GUARD ---------------
     Round 229 taught the /cart PAGE to notice an ORPHANED line: a bare
     /cart/add?id=<subscribe variant> permalink (an email blast, a product
     feed, an affiliate link, a bookmark) drops the SUBSCRIBE & SAVE variant
     in the bag at the SUBSCRIBER price with no selling plan on it. The
     visitor pays $35 for a $39 product, gets ONE bottle, and never gets a
     second - and until round 229 no screen said so.

     That fix never reached this drawer, which renders the same bag for the
     same visitor, because /cart.js does NOT expose
     variant.selling_plan_allocations - the exact field the page's
     discriminator is built on. So the drawer went on rendering the silent
     version of a bag the page had learned to tell the truth about.

     The missing field is one fetch away: /products/{handle}.js carries every
     variant's allocations. Cached per handle per page load, so a five-line
     bag of the same product is ONE request, and a failed fetch degrades to
     "say nothing" rather than to a false accusation.

     GOTCHA, measured against the live store rather than assumed, and it is
     the reason this is not a copy-paste of the Liquid: in the PRODUCT JSON an
     allocation carries a bare `selling_plan_id` NUMBER and no nested plan
     object, while in Liquid `alloc.selling_plan.name` is right there. The
     plan's NAME lives in product.selling_plan_groups[].selling_plans[]. Read
     off https://www.npgummy.com/products/relax-gummies.js 2026-08-23:

       variant 46101524742402 "Subscribe & Save"  price 3500  alloc price 3500
       variant 48264354464002 "One-Time Purchase" price 3900  alloc price 3500
       groups[0].selling_plans[0] = { id: 3971285250, name: "Every 30 days" }

     THE DISCRIMINATOR IS THE PAGE'S, VERBATIM, AND IT IS THE MONEY - never
     allocation-presence, which round 229 proved discriminates nothing because
     BOTH variants carry one. Fire only when the best plan on this variant
     saves the visitor NOTHING over what the variant already costs
     (best_plan_price >= variant.price). On the subscribe variant that is
     3500 >= 3500 -> true: they are paying the subscriber rate for a single
     shipment. On the one-time variant it is 3500 >= 3900 -> false: the plan
     WOULD have saved them $4, so a plan-less line there is a deliberate,
     correctly priced one-time order and it is left completely alone. */
  var npProdCache = {};
  function lineHandle(i) {
    if (i.handle) return i.handle;
    var m = (i.url || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : '';
  }
  function productJSON(h) {
    if (!h) return Promise.resolve(null);
    if (!npProdCache[h]) {
      npProdCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return npProdCache[h];
  }
  function planNameFrom(p, id) {
    var name = '';
    (p.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) { if (sp.id === id) name = sp.name; });
    });
    return name;
  }
  /* Exported on window for the round-233 falsifier, which runs this exact
     shipped function against fixtures instead of a retyped copy of it. */
  function orphanOf(item, product) {
    if (!item || item.selling_plan_allocation || !product || !product.variants) return null;
    var v = null, k;
    for (k = 0; k < product.variants.length; k++) {
      if (product.variants[k].id === item.variant_id) { v = product.variants[k]; break; }
    }
    if (!v || typeof v.price !== 'number') return null;
    var best = null;
    (v.selling_plan_allocations || []).forEach(function (a) {
      if (!a || typeof a.price !== 'number') return;
      if (best === null || a.price < best.price) best = a;
    });
    if (!best || best.price < v.price) return null;
    return {
      planId: best.selling_plan_id,
      planName: planNameFrom(product, best.selling_plan_id) || 'a repeat delivery',
      lineTotal: item.final_line_price
    };
  }
  window.npOrphanOf = orphanOf;
  function orphanMeta(c) {
    var uniq = {}, keys;
    c.items.forEach(function (i) { var h = lineHandle(i); if (h) uniq[h] = 1; });
    keys = Object.keys(uniq);
    return Promise.all(keys.map(productJSON)).then(function (list) {
      var by = {};
      keys.forEach(function (h, n) { by[h] = list[n]; });
      return c.items.map(function (i) { return orphanOf(i, by[lineHandle(i)]); });
    }).catch(function () { return c.items.map(function () { return null; }); });
  }

  /* One line item, rendered the same way in the drawer and (server-side) on
     /cart. Plan name first, because "Every 30 days" is the fact a subscriber
     is entitled to see before the Checkout button, not after the charge. */
  function lineHTML(i, idx, orph) {
    var plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan
      ? i.selling_plan_allocation.selling_plan.name : null;
    var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    /* ---- ROUND 241, backlog 281 - THE DISCOUNT THE BAG NEVER ADMITTED ----
       Proved against the live store before a line was changed (a real cart on
       www.npgummy.com, 2026-08-23): this store runs an automatic discount
       titled "2-Month Supply - 10% off". Put two one-time bottles in the bag
       and /cart.js comes back original_line_price 7800, final_line_price
       7020, total_discount 780 - and this renderer printed ONLY
       final_line_price. So the visitor saw "$70.20" against a bottle the
       whole site prices at $39.00, i.e. $35.10 each, a number that appears
       NOWHERE on npgummy.com. There was no strikethrough, no discount title
       and no savings line anywhere in this theme: the word `discount` matched
       zero times in assets/np.js and zero times in templates/cart.liquid,
       while sections/np-buybox.liquid:605 promises the visitor "Discount
       applied automatically at checkout". The site made a promise and then
       hid the payoff. An unexplained SMALLER number does not read as a win -
       it reads as a pricing bug, on the last screen before payment, which is
       the same failure shape as 276/277/278: money moved and the surface
       did not say so. */
    var discAmt = (i.original_line_price || 0) - (i.final_line_price || 0);
    var discTitle = '';
    (i.line_level_discount_allocations || []).forEach(function (a) {
      if (!discTitle && a && a.discount_application && a.discount_application.title) {
        discTitle = a.discount_application.title;
      }
    });
    var props = '';
    Object.keys(i.properties || {}).forEach(function (k) {
      if (k.charAt(0) === '_' || k === 'Plan' || !i.properties[k]) return;
      props += '<span class="ci-prop"><b>' + k + ':</b> ' + i.properties[k] + '</span>';
    });
    /* ---- ROUND 233, backlog 278 - THE DRAWER REMOVED THE WRONG BOTTLE ----
       Found while wiring the orphan control, proved against the live store
       before a line was changed (three throwaway carts on npgummy.com,
       2026-08-23): /cart/change.js's `line` is ONE-BASED. With two lines in
       the bag, {line:1, quantity:5} hit items[0], and {line:0, quantity:0}
       did not error - it silently removed the LAST line. This renderer was
       writing the map's ZERO-BASED index into data-line, and the shared
       quantity/remove handler below reads exactly that attribute and posts it
       as `line`. So in the DRAWER every +, - and Remove was off by one: press
       Remove on the first line and the bag lost the last one instead, with a
       200 and no error anywhere. The /cart PAGE was always correct - its
       Liquid writes {{ forloop.index }}, which is 1-based - so this is the
       same shape as 276/277 a third time: the page told the truth and the
       drawer did not. One character of arithmetic; a visitor deleting the
       wrong product on the last screen before payment. */
    var lineNo = idx + 1;
    return '<div class="ci" data-line="' + lineNo + '">' +
      '<a class="ci-img" href="' + i.url + '"><img src="' + img + '" alt="" width="200" height="200"></a>' +
      '<div class="ci-main">' +
        '<b>' + i.product_title + '</b>' +
        /* Orphan chip + the one control that fixes it. Deliberately reuses the
           PAGE's own ink (.cline-plan--orphan, .cline-fix) on the drawer's own
           pill base (.ci-plan) so the two surfaces cannot drift apart visually
           and no new CSS is written this round - assets/np.css closes
           byte-identical. The href is a real server-side /cart/change so it
           works with this script broken; the click handler upgrades it to
           ajax. Plan id and cadence are read from the store, never hardcoded:
           rename or re-cadence the plan and this follows it. */
        (plan ? '<span class="ci-plan">' + plan + ' · cancel anytime</span>'
              : (orph
                  ? '<span class="ci-plan cline-plan--orphan" data-ci-orphan>Not set to repeat yet</span>' +
                    '<a class="cline-fix" href="/cart/change?line=' + lineNo + '&amp;selling_plan=' + orph.planId + '"' +
                    ' data-ci-fix="' + orph.planId + '" data-ci-fix-line="' + lineNo + '">Make it ' +
                    String(orph.planName).toLowerCase() + ' \u2192</a>'
                  : (i.variant_title && i.variant_title !== 'Default Title'
                      ? '<span class="ci-plan ci-plan--once">' + i.variant_title + '</span>' : ''))) +
        props +
        (discAmt > 0
          ? '<span class="ci-disc" data-ci-disc>' + (discTitle || 'Automatic discount') +
            ' \u00b7 \u2212' + money(discAmt) + '</span>'
          : '') +
        '<div class="ci-qty">' +
          '<button type="button" class="qbtn" data-line-qty="' + (i.quantity - 1) + '" aria-label="Reduce quantity">−</button>' +
          '<span class="qnum" aria-live="polite">' + i.quantity + '</span>' +
          '<button type="button" class="qbtn" data-line-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '<button type="button" class="ci-rm" data-line-qty="0">Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="ci-price">' +
        (discAmt > 0
          ? '<s class="ci-was">' + money(i.original_line_price) + '</s>' +
            '<span class="ci-now">' + money(i.final_line_price) + '</span>'
          : money(i.final_line_price)) +
      '</div>' +
    '</div>';
  }

  /* ---- LIVE FIX 2026-08-16 (Jared video) — THE FROZEN SUBSCRIPTION PRICE ----
     Jared's recording (11:15 PT): PDP said "$35 · $1.17/day", Subscribe & Save
     selected; the bag drawer said $69.00/unit — $138.00 for qty 2 — WITH the
     "Every 30 days · cancel anytime" badge attached. Everything on both screens
     was rendering exactly what Shopify's own /cart.js returned. Nothing in this
     theme dropped the selling_plan (the round-176 contract held: the plan WAS
     attached), and nothing in this theme invented $69.

     ROOT CAUSE, reproduced live with two throwaway carts before this was
     written, not guessed: Shopify FREEZES a cart line's charged price
     (final_price) at the moment the line is added, for lines that carry a
     selling plan. Changing the selling plan's fixed-price policy afterwards
     does NOT reprice existing cart lines — and /cart/add.js MERGES a new add of
     the same variant+plan into the old line, so the new unit inherits the old
     frozen price instead of taking the current one. Measured 2026-08-16:
       - line added while plan=$35, policy flipped to $69: final_price stays
         3500 while selling_plan_allocation.price reads the live 6900
       - line added while plan=$69, policy reverted to $35: final_price stays
         6900 FOREVER against a live allocation of 3500 — checkout would charge
         the $69. That is Jared's cart: the store's pricing was restructured
         $69 -> $35 at 10:23 AM the same morning, his bag already held a
         pre-restructure line, and his new add merged into it.
     So /cart.js hands us the detector for free: a line whose final_price does
     not equal its own selling_plan_allocation.price is frozen-stale. The fix
     re-anchors it — remove the line, re-add the same variant + plan +
     properties + quantity, which re-freezes it at the CURRENT plan price.
     Runs on every renderCart(), i.e. on every page load (line below the
     function) and every drawer open, so a returning visitor with a stale bag
     is repriced before they can reach Checkout.
     GUARDS, each load-bearing:
       - one attempt per page load (frozenFixed) — /cart.js's allocation field
         lags the admin by ~a minute after a policy change, so a false positive
         must never loop remove/re-add.
       - sessionStorage cross-load guard, CLEARED on any clean read: if a
         reconcile did not actually fix the line (add failed, item gone), the
         next load skips instead of hammering; the flag resets the moment the
         cart reads clean so a future genuine repricing still reconciles.
       - remove-then-add order is forced by the merge behaviour above: add-first
         merges into the frozen line and inherits the very price being fixed.
       - on /cart (tpl-cart) the page body is server-rendered from the same
         frozen line, so a successful reconcile reloads once; the fresh state
         reads clean on the next pass, which is what terminates the cycle. */
  var frozenFixed = false;
  function reconcileFrozen(c) {
    if (!c || !c.items) return Promise.resolve(c);
    var stale = c.items.filter(function (i) {
      return i.selling_plan_allocation &&
             typeof i.selling_plan_allocation.price === 'number' &&
             i.final_price !== i.selling_plan_allocation.price;
    });
    if (!stale.length) {
      try { sessionStorage.removeItem('np-frozen-fixed'); } catch (err) {}
      return Promise.resolve(c);
    }
    if (frozenFixed) return Promise.resolve(c);
    frozenFixed = true;
    try {
      if (sessionStorage.getItem('np-frozen-fixed')) return Promise.resolve(c);
      sessionStorage.setItem('np-frozen-fixed', '1');
    } catch (err) {}
    var chain = Promise.resolve();
    stale.forEach(function (i) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: i.key, quantity: 0 })
        });
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: i.variant_id,
            quantity: i.quantity,
            selling_plan: i.selling_plan_allocation.selling_plan.id,
            properties: i.properties || {}
          })
        });
      });
    });
    return chain.then(function () {
      if (document.body.classList.contains('tpl-cart')) window.location.reload();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }).catch(function () { return c; });
  }

  /* ---- SHIPPING LINE + ONE-BOTTLE NUDGE (2026-10-11, Jared msg 61611) ----
     Admin now charges Economy $4.95 flat and ships free at $60+, and the
     automatic "Free shipping on subscriptions" discount makes every
     Subscribe & Save order ship free. This drawer used to tell EVERY bag
     "Shipping is free." - which was a lie for a single one-time bottle. It
     now reads the two numbers off the .drawer data-ship-* attributes (cents,
     set in layout/theme.liquid next to the admin rule) and tells the truth
     per bag. Nothing money-shaped is typed in this file.
     The nudge fires ONLY for a bag that is exactly one one-time bottle and
     offers the two one-tap moves that make shipping free:
       (a) switch the line to the subscription: remove the line, re-add the
           product's subscription variant WITH its plan - the same shape the
           buybox carts (path A in templates/cart.liquid) - so the line reads
           "Subscribe & Save · Every 30 days", not "One-Time Purchase ·
           Every 30 days". Plan id, plan price and target variant are read
           off /products/{handle}.js (already cached by orphanMeta), never
           hardcoded: rename or re-price the plan and this follows it.
       (b) bump the line to quantity 2 (the 2-Month Supply automatic discount
           then lands on its own; the bag re-renders with the strike).
     Both anchors carry a real server-side /cart/change href so the control
     still works with this script dead; the click handler below upgrades it
     to ajax. The slot is emptied the moment the bag ships free, so a
     qualifying bag never sees it. */
  function shipCfg() {
    var d = $('.drawer');
    return {
      flat: d ? parseInt(d.getAttribute('data-ship-flat') || '0', 10) : 0,
      freeMin: d ? parseInt(d.getAttribute('data-ship-free-min') || '0', 10) : 0
    };
  }
  function shipsFree(c, cfg) {
    var sub = c.items.some(function (i) { return !!i.selling_plan_allocation; });
    return sub || !cfg.flat || c.total_price >= cfg.freeMin;
  }
  function subTargetFor(item, product) {
    /* Measured on the live store 2026-10-11 (/products/relax-gummies.js): the
       One-Time Purchase variant carries NO selling_plan_allocations any more
       (the plan group is attached to the Subscribe & Save variant only), so
       the plan has to be found across the PRODUCT's variants, not on the line's
       own variant. Pick the cheapest allocation on any variant that actually
       saves money against what the line costs now; that variant + that plan is
       what the buybox would have carted. */
    if (!item || !product || !product.variants) return null;
    var best = null, target = null, k;
    for (k = 0; k < product.variants.length; k++) {
      var w = product.variants[k];
      (w.selling_plan_allocations || []).forEach(function (a) {
        if (!a || typeof a.price !== 'number' || a.price >= item.final_price) return;
        if (best === null || a.price < best.price) { best = a; target = w; }
      });
    }
    if (!best || !target) return null;
    return {
      planId: best.selling_plan_id,
      planPrice: best.price,
      variantId: target.id,
      label: (target.title && target.title !== 'Default Title') ? target.title : 'Subscribe & Save'
    };
  }
  window.npSubTargetFor = subTargetFor;
  function nudgeHTML(item, tgt, cfg) {
    var opts = '', saving;
    if (tgt) {
      saving = (item.final_price + cfg.flat) - tgt.planPrice;
      opts += '<a class="ship-nudge-btn" href="/cart/change?line=1&amp;selling_plan=' + tgt.planId + '"' +
        ' data-nudge-sub="' + tgt.variantId + '" data-nudge-plan="' + tgt.planId + '" data-nudge-key="' + item.key + '">' +
        '<b>Switch to ' + tgt.label + ', ' + money(tgt.planPrice) + '/mo, ships free</b>' +
        (saving > 0
          ? '<span>' + money(saving) + ' less than ' + money(item.final_price) + ' + ' + money(cfg.flat) + ' shipping. Skip or cancel anytime.</span>'
          : '') +
        '</a>';
    }
    if (item.final_price * 2 >= cfg.freeMin) {
      opts += '<a class="ship-nudge-btn" href="/cart/change?line=1&amp;quantity=2" data-nudge-add="' + item.key + '">' +
        '<b>Add a 2nd bottle, shipping is free</b>' +
        '<span>Two bottles clear the ' + money(cfg.freeMin) + ' free shipping mark.</span></a>';
    }
    if (!opts) return '';
    return '<p class="ship-nudge-h">Shipping is ' + money(cfg.flat) + ' on one bottle. Two ways to make it free:</p>' + opts;
  }
  function renderShip(c) {
    var cfg = shipCfg(), free = shipsFree(c, cfg);
    var line = $('.drawer [data-cart-ship]');
    if (line) line.textContent = (free ? 'Shipping is free.' : 'Shipping is ' + money(cfg.flat) + '.') + ' Taxes are calculated at checkout.';
    var slot = $('.drawer [data-ship-nudge]');
    if (!slot) return;
    var one = c.items.length === 1 && c.items[0].quantity === 1 && !c.items[0].selling_plan_allocation;
    if (free || !one) { slot.hidden = true; slot.innerHTML = ''; return; }
    var item = c.items[0];
    productJSON(lineHandle(item)).then(function (p) {
      var html = nudgeHTML(item, subTargetFor(item, p), cfg);
      slot.innerHTML = html;
      slot.hidden = !html;
    });
  }

  function renderCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(reconcileFrozen)
      .then(function (c) { return orphanMeta(c).then(function (meta) { return { c: c, meta: meta }; }); })
      .then(function (bag) {
        var c = bag.c, meta = bag.meta;
        /* Scope every write to .drawer. Round 64 defect, caught on the live
           capture: /cart's summary card also carries [data-cart-total], it
           comes FIRST in document order, so an unscoped querySelector made
           this renderer overwrite the server-rendered "$69.00" with its own
           "$69" - two different money formats eight pixels apart on the last
           screen before payment. A shared renderer must never reach outside
           the surface it owns. */
        var body = $('.drawer-body'), tot = $('.drawer [data-cart-total]'), cnt = $$('.cart-count');
        var sub = c.items.filter(function (i) { return i.selling_plan_allocation; }).length;
        /* ROUND 233, backlog 277 - THE DAY 30 ROW NAMED NO NUMBER.
           Round 215 removed the string "The next one renews" from the /cart
           page because it tells a subscriber nothing about the one fact they
           are entitled to before the Checkout button: HOW MUCH. It was never
           removed from this drawer, so the same visitor got the vague version
           in the panel that actually opens on every add-to-cart. Money is
           summed the same way the page sums it - only the lines that ACTUALLY
           recur - so a mixed bag cannot promise to renew a one-time bottle. */
        var subTotal = 0, onceTotal = 0, orphanTotal = 0, orphanCadence = '';
        /* Backlog 281, bag edition. The line cells above own the per-line
           strike; this owns the one sentence the whole bag owes the visitor -
           that the total already has the discount taken OUT of it, so nobody
           waits for a second reduction at checkout that is never coming.
           Title is read from the store, never hardcoded: rename the discount
           in Shopify admin and this follows it. */
        var cartDiscTitle = '';
        c.items.forEach(function (i) {
          (i.line_level_discount_allocations || []).forEach(function (a) {
            if (!cartDiscTitle && a && a.discount_application && a.discount_application.title) {
              cartDiscTitle = a.discount_application.title;
            }
          });
        });
        (c.cart_level_discount_applications || []).forEach(function (a) {
          if (!cartDiscTitle && a && a.title) cartDiscTitle = a.title;
        });
        c.items.forEach(function (i, n) {
          if (i.selling_plan_allocation) { subTotal += i.final_line_price; return; }
          onceTotal += i.final_line_price;
          if (meta[n]) {
            orphanTotal += i.final_line_price;
            if (!orphanCadence) orphanCadence = String(meta[n].planName).toLowerCase();
          }
        });
        cnt.forEach(function (n) { n.textContent = c.item_count; n.style.display = c.item_count ? 'grid' : 'none'; });
        if (!body) return c;
        if (!c.items.length) {
          body.innerHTML = '<div class="drawer-empty"><b>Your bag is empty.</b>' +
            '<p>The 30-day pack is where almost everyone starts.</p>' +
            '<a class="btn" href="/products/relax-gummies">Start the path</a></div>';
        } else {
          /* Round 64: one line item left ~500px of empty cream under it. The
             three facts a subscriber most wants at this exact moment - what is
             charged now, when it ships, what happens on day 30 - were nowhere
             on the screen. They go in the dead space. */
          body.innerHTML = c.items.map(function (i, n) { return lineHTML(i, n, meta[n]); }).join('') +
            '<div class="cnext"><span class="cnext-h">What happens next</span>' +
            '<div class="cnext-r"><b>Today</b><span>' + money(c.total_price) + ' is charged. Nothing else.</span></div>' +
            ((c.total_discount || 0) > 0
              ? '<div class="cnext-r cnext-r--save"><b>You saved</b><span>' + money(c.total_discount) +
                ' came off' + (cartDiscTitle ? ' for ' + cartDiscTitle : ' automatically') +
                '. The number above is already after it, not before.</span></div>'
              : '') +
            '<div class="cnext-r"><b>1 to 2 days</b><span>It ships ' + (shipsFree(c, shipCfg()) ? 'free' : 'for ' + money(shipCfg().flat)) + '. Tracking lands in your inbox.</span></div>' +
            (sub
              ? '<div class="cnext-r"><b>Day 30</b><span>' + money(subTotal) + ' renews' +
                (onceTotal > 0 ? ', and only that' : '') +
                '. Skip it, push it back or cancel from your account.</span></div>'
              : '') +
            /* The absence is a fact too. Round 229's lesson on the page: a bag
               that is not set to repeat used to just STOP after "1 to 2 days",
               and a MISSING sentence looks exactly like a correct one. */
            (orphanTotal > 0 && !sub
              ? '<div class="cnext-r cnext-r--orphan"><b>Day 30</b><span>Nothing. This order is not set to repeat, so it is charged once and ships once.</span></div>'
              : '') +
            '</div>';
        }
        if (tot) tot.textContent = money(c.total_price);
        var totLbl = $('.drawer .drawer-tot > span:first-child');
        if (totLbl) totLbl.textContent = (c.total_discount || 0) > 0 ? 'Total today' : 'Subtotal';
        var note = $('.drawer [data-cart-subnote]');
        if (note) {
          if (sub) {
            note.textContent = 'Subscription. ' + money(subTotal) + ' renews on each cycle. Skip or cancel before the next charge and nothing goes through.';
            note.hidden = false;
            note.removeAttribute('data-np-r233');
          } else if (orphanTotal > 0) {
            /* The disclosure, drawer edition. Same money, same words as the
               page's .cart-orphan-note, so a visitor who opens both does not
               get two different accounts of their own bag. */
            note.textContent = 'This bag is at the subscriber price, but ' + money(orphanTotal) +
              ' of it is not set to repeat - it is charged once and nothing ships after that. Use "Make it ' +
              orphanCadence + '" on the line above to turn it on, or leave it and this stays a one-time order.';
            note.hidden = false;
            note.setAttribute('data-np-r233', 'orphan-plan-guard');
          } else { note.hidden = true; note.removeAttribute('data-np-r233'); }
        }
        renderShip(c);
        var ft = $('.drawer-ft');
        if (ft) ft.style.display = c.items.length ? '' : 'none';
        return c;
      });
  }
  renderCart();

  /* ---- the one-bottle nudge, both surfaces (2026-10-11) ----
     Drawer anchors are rendered by renderShip(); the /cart page renders the
     same anchors server-side (templates/cart.liquid) with the same
     data-nudge-* contract. Works with this dead: the href is a real
     /cart/change. The subscription swap is remove-then-add on purpose -
     /cart/add.js MERGES a same-variant add into an existing line, and
     the LIVE FIX 2026-08-16 note above explains why a merged line can
     inherit a stale frozen price. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nudge-sub], [data-nudge-add]');
    if (!a) return;
    e.preventDefault();
    var href = a.getAttribute('href'), req;
    var hdr = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    a.classList.add('is-busy');
    if (a.hasAttribute('data-nudge-add')) {
      req = fetch('/cart/change.js', { method: 'POST', headers: hdr,
        body: JSON.stringify({ id: a.getAttribute('data-nudge-add'), quantity: 2 }) });
    } else {
      req = fetch('/cart/change.js', { method: 'POST', headers: hdr,
        body: JSON.stringify({ id: a.getAttribute('data-nudge-key'), quantity: 0 }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: hdr,
            body: JSON.stringify({
              id: parseInt(a.getAttribute('data-nudge-sub'), 10),
              quantity: 1,
              selling_plan: parseInt(a.getAttribute('data-nudge-plan'), 10)
            }) });
        });
    }
    req.then(function (r) { if (!r.ok) throw new Error('nudge failed'); return r.json(); })
      .then(function () {
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
        return renderCart();
      })
      .catch(function () { if (href) window.location.href = href; });
  });

  /* ---- ROUND 233, backlog 276 - the orphan control, drawer edition ----
     The anchor's href is a real server-side /cart/change and works with this
     handler dead; this upgrades it to ajax so the bag does not blink. Uses a
     DIFFERENT attribute from the page's [data-cline-fix] on purpose - the two
     surfaces never collide, and on /cart the page's own link keeps its plain
     navigation. Verified live before shipping: POST /cart/change.js with
     {line:1, selling_plan:3971285250} returns 200 and the line comes back
     carrying "Every 30 days". */
  document.addEventListener('click', function (e) {
    var fx = e.target.closest('[data-ci-fix]');
    if (!fx) return;
    e.preventDefault();
    var href = fx.getAttribute('href');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: parseInt(fx.getAttribute('data-ci-fix-line'), 10),
        selling_plan: parseInt(fx.getAttribute('data-ci-fix'), 10)
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () {
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
        return renderCart();
      })
      .catch(function () { if (href) window.location.href = href; });
  });

  /* ---- line quantity + remove, drawer and /cart page ----
     On /cart the controls are real <a href="/cart/change?line=N&quantity=Q">
     links rendered by Liquid, so the page works with this script disabled.
     This upgrades them to ajax; it does not create them. */
  document.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-line-qty], [data-qty-step]');
    if (!ctl) return;
    var row = ctl.closest('[data-line]');
    if (!row) return;
    e.preventDefault();
    var q = parseInt(ctl.getAttribute('data-line-qty') || ctl.getAttribute('data-qty-step'), 10);
    if (isNaN(q) || q < 0) q = 0;
    ctl.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(row.getAttribute('data-line'), 10), quantity: q })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
        return renderCart();
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  /* ---- ajax add to cart ----
     2026-10-14 (np-meta-tof-abo-build): the buy button used to reach this code
     through a native form SUBMIT. Shopify's cart monitor counts a submit on a
     form[action="/cart/add"] as one add-to-cart AND the fetch below as another,
     so the Meta pixel got AddToCart twice per click (measured: 2 on the buy box,
     1 for a bare fetch). The click is now intercepted before the form submits,
     so only the fetch is seen. The submit listener stays as the fallback. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[data-ajax-cart] [type="submit"]');
    if (!b) return;
    var f = b.closest('form[data-ajax-cart]');
    if (!f || (f.checkValidity && !f.checkValidity())) return;
    e.preventDefault();
    npAjaxAdd(f);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    npAjaxAdd(f);
  });
  function npAjaxAdd(f) {
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    lastOpener = btn || null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return renderCart(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } openDrawer(); })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } f.submit(); });
  }

  /* ---- press marquee duplication ----
     Round 52: the liquid already renders the list twice (second pass
     aria-hidden) and this line doubles that again for the -50% loop, so the
     track holds four copies. Before this fix two of those four were readable,
     which made a screen reader announce the whole Supplement Facts strip
     twice. Everything the clone adds is decorative by definition - the
     authoritative copy is the first set - so hide the clone from the a11y
     tree instead of just appending markup. */
  $$('.press-track').forEach(function (t) {
    var clone = t.cloneNode(true);
    var kids = clone.children, i;
    for (i = 0; i < kids.length; i++) kids[i].setAttribute('aria-hidden', 'true');
    while (clone.firstChild) t.appendChild(clone.firstChild);
  });
})();

/* ============================================================
   ROUND 07 — MOTION & FEEL
   Scroll-driven pinned actives sequence + staggered reveals.
   No dependencies, rAF-throttled, reduced-motion safe.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* ROUND 180, backlog 174 — held query, read at USE time.

     The fifth and last of the one-shot reads, and the only one that needed
     reading twice before it was touched. This IIFE looks like it contains an
     entrance (`runStatic()` ADDS `.on`, which is a visibility class) and round
     178's lesson 3 bars arming an entrance late. It is not one: `enter`/`leave`
     is a three-mode machine whose `static` branch is the REDUCED path, and
     `leave()` already strips `.on` and every `--ap` before the next mode is
     entered. So a preference flip walks the same road a resize across 900px has
     walked since round 80 — a road with a proven handback — and no authored
     hidden state is ever re-imposed on content already on screen.

     `bootSpin()` is deliberately included: it is called from `enter('pin')`, so
     a session that opened reduced now decodes the sprite sheet at the moment of
     the flip instead of never, and the turntable works for that visitor. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  /* ---- staggered reveal on grid-shaped .rv blocks below the fold ---- */
  $$('.rv').forEach(function (el) {
    var n = el.children.length;
    if (n < 3 || n > 6) return;
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    var d = window.getComputedStyle(el).display;
    if (d.indexOf('grid') === -1 && d.indexOf('flex') === -1) return;
    el.classList.add('rv-stagger');
  });

  /* ---- pinned actives sequence ---- */
  var seq = $('[data-seq]');
  if (!seq) return;

  var track = $('.seq-track', seq);
  var stage = $('.seq-stage', seq);
  var annots = $$('.seq-a', seq);
  var bar = $('[data-seq-bar]', seq);
  var count = $('[data-seq-count]', seq);
  if (!track || !stage) return;

  /* ---- ROUND 14: real frame sequence ----
     33 rendered turntable frames on a 6x6 sprite sheet. The sheet is decoded
     once, off the critical path; only when it is actually ready do we swap the
     static render for the sequence, so a slow connection degrades to the
     still image instead of an empty box. */
  var pack = $('[data-seq-pack]', seq);
  var spin = $('[data-seq-spin]', seq);
  var spinReady = false, spinFrames = 0, spinCols = 6, lastFrame = -1;
  function bootSpin() {
    if (!spin || !pack || isReduced()) return;
    spinFrames = parseInt(spin.getAttribute('data-frames'), 10) || 0;
    spinCols = parseInt(spin.getAttribute('data-cols'), 10) || 6;
    var url = spin.getAttribute('data-src');
    if (!url || !spinFrames) return;
    var pre = new Image();
    pre.decoding = 'async';
    pre.onload = function () {
      spin.style.backgroundImage = 'url("' + url + '")';
      spinReady = true;
      pack.classList.add('spun');
      lastFrame = -1;
      paintSpin(parseFloat(stage.style.getPropertyValue('--p')) || 0);
    };
    pre.src = url;
  }
  function paintSpin(p) {
    if (!spinReady) return;
    var i = Math.round(p * (spinFrames - 1));
    if (i === lastFrame) return;
    lastFrame = i;
    spin.style.setProperty('--sx', String(i % spinCols));
    spin.style.setProperty('--sy', String(Math.floor(i / spinCols)));
  }

  var isPinned = function () {
    return !isReduced() && window.innerWidth > 900;
  };

  /* ============================================================
     ROUND 80 — THE PHONE WALK (axis 5, backlog 43a)

     THE GATE WAS NOT LOWERED. `isPinned()` above is still
     `innerWidth > 900` and the pin is still desktop-only, for the
     reason backlog 43 has given since round 72: a 1,097px pin on an
     844px viewport, with a stage laid out for 1800px, traps the
     visitor in a broken sticky. What round 80 adds is the thing that
     was actually missing — a SECOND branch under the gate, so the
     phone gets different geometry and different timing instead of NO
     timing. Same rule round 72 established, round 77 used for the shop
     deal and round 79 used for `easy`.

     What shipped for 79 rounds below 900px: `runStatic()` handed the
     six cards to an IntersectionObserver one-shot fade, set the bar to
     `scaleX(1)` and wrote "6" into the counter on load. So the phone's
     progress bar was full and its counter read "6 of 6 revealed"
     before a single card had been looked at — the one section whose
     whole pitch is a count. That is not a missing animation, it is a
     counter that lied.

     THE WALK: the annotation LIST is the travel. Its own rect drives a
     single 0->1 `p`, six overlapping slices ride it, and the counter,
     the foot bar, the sticky HUD and the glow all read off the same
     numbers the cards are showing.

     WHY THE LIST'S RECT AND NOT EACH CARD'S OWN: round 77's shop-deal
     branch drives each card off its own rect, and it has to, because
     that grid is 2,377px tall at one column — a shared window there
     gives each card ~800px of scroll for 34px of lift, which is not
     slow motion, it is no motion. This list is ~600px for six cards,
     so a shared window gives ~150px of scroll per card and lets the
     six slices tile ONE ramp — which is what makes a COUNTER honest.
     Per-card rects have no shared p, so there is nothing for a count
     of six to be a fraction OF. Different problem, different answer.

     HOUSE INVARIANT, fourth system to carry it: W_END + W_SPAN == 1.0,
     so the LAST active finishes arriving exactly at p = 1, the same
     rule as `C_END + C_SPAN` (rounds 71, 77) and `R_END + R_SPAN`
     (round 76). If these stop summing to 1.0 the sixth active is still
     in flight when the list has fully passed and the counter can never
     reach six on a phone.
     ============================================================ */
  var list = $('[data-seq-list]', seq);
  var hud = $('[data-seq-hud]', seq);
  var hudFill = $('[data-seq-hud-fill]', seq);
  var hudCount = $('[data-seq-hud-count]', seq);

  /* The window: opens as the list's top edge crosses 90% of the viewport,
     closes when its BOTTOM edge reaches 42% — so the sixth card completes
     while it is still comfortably on screen, not as it exits the top. The
     denominator scales with the list's own height, so a seventh active or a
     wrapped card buys itself proportional travel instead of compressing the
     ramp. L_FLOOR is the collapse guard, same shape as round 77's P_FLOOR. */
  var L_IN = 0.90, L_OUT = 0.42, L_FLOOR = 0.40;
  /* ---- ROUND 93: W_END IS DERIVED, NOT TYPED (axis 5, backlog 71) ----
     Same change, same reason, third of the three drivers that state this
     invariant. The block above calls it a "HOUSE INVARIANT" and then types
     both halves of it, so "MUST sum to 1.0" was a comment asking to be
     obeyed rather than arithmetic that cannot be disobeyed. If they stop
     summing to 1.0 the sixth active is still in flight when the list has
     fully passed and the phone's counter can never reach six - which is the
     one thing this section's whole pitch rests on. 0.72 == 1 - 0.28, so
     nothing moves today; `--target seqwalk` is the instrument that catches
     it if it ever would. */
  var W_SPAN = 0.28;
  var W_END = 1 - W_SPAN;   /* INVARIANT: last active must END at p = 1 */
  var walkShown = -1;

  function isWalk() { return !isReduced() && window.innerWidth <= 900 && !!list; }

  function walkFrame() {
    if (!list) return;
    var vh = window.innerHeight || 1;
    var r = list.getBoundingClientRect();
    var travel = r.height + vh * (L_IN - L_OUT);
    if (travel < vh * L_FLOOR) travel = vh * L_FLOOR;
    var p = (vh * L_IN - r.top) / travel;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);

    /* the glow and the pack ride the same p — on desktop those are driven by
       the pin's --p, and this is the phone's version of the same thing. */
    stage.style.setProperty('--p', p.toFixed(4));

    var n = annots.length;
    var step = n > 1 ? W_END / (n - 1) : 0;
    var shown = 0, sum = 0;
    annots.forEach(function (a, i) {
      var ap = (p - step * i) / W_SPAN;
      ap = ap < 0 ? 0 : (ap > 1 ? 1 : ap);
      var e = 1 - Math.pow(1 - ap, 3);
      a.style.setProperty('--ap', e.toFixed(4));
      sum += e;
      /* same 0.98 the pin uses, and for the same measured reason (round 55):
         cubic ease-out is visually arrived well before raw progress is 1. */
      var on = e >= 0.98;
      if (on) shown++;
      a.classList.toggle('on', on);
    });
    var fill = sum / Math.max(1, n);
    fill = fill < 0 ? 0 : (fill > 1 ? 1 : fill);

    if (bar) bar.style.transform = 'scaleX(' + fill.toFixed(4) + ')';
    if (hudFill) hudFill.style.transform = 'scaleX(' + fill.toFixed(4) + ')';
    if (shown !== walkShown) {
      if (count) count.textContent = String(shown);
      if (hudCount) {
        hudCount.textContent = String(shown);
        /* the round-07 tick driver only watches the FIRST [data-seq-count] in
           the document, so the HUD pops its own counter. */
        hudCount.classList.remove('tick');
        void hudCount.offsetWidth;
        hudCount.classList.add('tick');
      }
      walkShown = shown;
    }
  }

  /* small-screen / reduced-motion path: plain intersection reveal */
  var staticIO = null;
  function runStatic() {
    /* round 55: hand the cards back to the class-toggle path — drop the
       scroll-driven flag and clear every --ap so the CSS transitions own
       them again instead of a frozen mid-arrival value. */
    seq.classList.remove('seq--live');
    annots.forEach(function (a) { a.style.removeProperty('--ap'); });
    annots.forEach(function (a, i) {
      if (isReduced()) { a.classList.add('on'); return; }
      if (!('IntersectionObserver' in window)) { a.classList.add('on'); return; }
      if (!staticIO) {
        staticIO = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('on'); staticIO.unobserve(e.target); }
          });
        }, { threshold: 0.25, rootMargin: '0px 0px -30px' });
      }
      staticIO.observe(a);
    });
    if (bar) bar.style.transform = 'scaleX(1)';
    if (count) count.textContent = String(annots.length);
    stage.style.setProperty('--p', '1');
  }

  var ticking = false;
  var lastShown = -1;

  /* One rAF, three modes. `pin` and `walk` are BRANCHES of the same system —
     same cards, same `--ap`, same 0.98 arrival threshold, same counter — and
     only the geometry and the source of `p` differ. `static` (reduced motion,
     or no list) is the only path that still hands the cards to the CSS. */
  function frame() {
    ticking = false;
    if (isPinned()) { pinFrame(); return; }
    if (isWalk()) { walkFrame(); return; }
  }

  function pinFrame() {
    var r = track.getBoundingClientRect();
    var span = r.height - window.innerHeight;
    if (span <= 0) return;
    var p = (-r.top) / span;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);

    stage.style.setProperty('--p', p.toFixed(4));
    paintSpin(p);

    /* ---- ROUND 50: actives reveal across 8% -> 88% of the pin ----
       The ramp used to divide by `annots.length`, so the LAST active fired at
       start + step*(n-1) = 0.747, not at the 0.88 the variable named `end`
       claims. Measured on the live theme: with six actives, everything was lit
       by p=0.747 and the remaining 25.3% of the pin (182 of 720px of travel)
       had no reveal left to run. Dividing by (n-1) makes the last item land on
       `end` exactly, which is what the constant was always meant to mean. */
    /* ---- ROUND 55: continuous per-active arrival, not six switches ----
       Round 50 fixed WHERE the last card fires; this fixes HOW every card
       fires. `on` was a boolean crossing a threshold, so each annotation
       snapped. Now each card owns a contiguous slice of the reveal ramp and
       gets a 0->1 `--ap` written every frame, which CSS maps onto opacity +
       translate + scale + saturate. Six slices of w = (end-start)/n tile
       [start, end] exactly: card 0 finishes arriving at start+w, card n-1
       finishes at `end` — the same 0.88 the counter and bar have used since
       round 50, so nothing downstream had to be re-tuned.

       Slice width, not threshold spacing: dividing by (n-1) as the old ramp
       did would put card n-1's slice END at end+w, i.e. past the pin, and it
       would never fully arrive. Divide by n. */
    var start = 0.08, end = 0.88;
    var w = (end - start) / Math.max(1, annots.length);
    var shown = 0, sum = 0, seqFill = 0;
    annots.forEach(function (a, i) {
      var ap = (p - (start + w * i)) / w;
      ap = ap < 0 ? 0 : (ap > 1 ? 1 : ap);
      /* ease-out so a card decelerates into place instead of sliding linearly */
      var e = 1 - Math.pow(1 - ap, 3);
      a.style.setProperty('--ap', e.toFixed(4));
      sum += e;
      /* COUNT WHAT THE EYE SEES, NOT THE RAW THRESHOLD. Cubic ease-out is at
         99.9% arrived while raw progress is only 0.90, so counting `ap >= 1`
         showed "3 of 6" in a frame where four cards were visually lit — the
         exact class of counter/visual disagreement round 50 fixed at the other
         end of the ramp. Caught in this round's pin-seq-60 shot by eye, not by
         a metric. The card is "revealed" once its eased arrival is complete. */
      var on = e >= 0.98;
      if (on) shown++;
      a.classList.toggle('on', on);
    });
    seqFill = sum / Math.max(1, annots.length);
    if (count && shown !== lastShown) { count.textContent = String(shown); lastShown = shown; }

    /* The bar is labelled by the counter next to it ("n of 6 revealed"), so it
       must track the REVEAL ramp, not raw pin progress. Driving it off `p` had
       it sitting at 75% the moment the sixth active lit, then crawling to full
       against a counter that had already stopped moving. Now bar full == 6 of 6.

       ROUND 55: the bar is now the MEAN of the six eased arrivals rather than a
       parallel linear ramp off `p`. Two things fall out of that. It is itself
       scroll-driven by the same numbers the cards are showing, and it can only
       reach 1.0 when all six are fully arrived, so round 50's "bar full == 6 of
       6" invariant now holds by construction instead of by two constants
       happening to agree. Mid-pin it sits within 0.02/6 of counter/6. */
    if (bar) {
      var pr = seqFill;
      pr = pr < 0 ? 0 : (pr > 1 ? 1 : pr);
      bar.style.transform = 'scaleX(' + pr.toFixed(4) + ')';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  /* 'pin' | 'walk' | 'static'. Round 80 turned this from a boolean into three
     states; before it, everything that was not the pin was the static fade. */
  function modeNow() { return isPinned() ? 'pin' : (isWalk() ? 'walk' : 'static'); }

  function enter(m) {
    if (m === 'pin') {
      seq.classList.remove('seq--walk');
      seq.classList.add('seq--live');
      if (spinReady && pack) pack.classList.add('spun'); else bootSpin();
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (m === 'walk') {
      /* `seq--live` is what makes the CSS read `--ap` instead of transitioning
         off `.on`, so the walk needs it too — the phone-only geometry rides on
         `seq--walk` alongside it, never instead of it. The spin sheet stays
         OFF on the phone (`.seq-spin{display:none}` below 900px since round
         14); decoding a 6x6 sprite for an element that is display:none is the
         kind of thing that makes a phone build feel slow. */
      if (pack) pack.classList.remove('spun');
      seq.classList.add('seq--live');
      seq.classList.add('seq--walk');
      walkShown = -1;
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      window.removeEventListener('scroll', onScroll);
      if (pack) pack.classList.remove('spun');
      seq.classList.remove('seq--walk');
      runStatic();
    }
  }

  function leave() {
    window.removeEventListener('scroll', onScroll);
    annots.forEach(function (a) { a.classList.remove('on'); a.style.removeProperty('--ap'); });
    lastShown = -1; walkShown = -1;
    if (bar) bar.style.transform = 'scaleX(0)';
    if (hudFill) hudFill.style.transform = 'scaleX(0)';
  }

  var mode = modeNow();

  /* ROUND 180 — one handler, two events. */
  function reassess() {
    var next = modeNow();
    if (next !== mode) { leave(); mode = next; enter(next); }
    else { onScroll(); }
  }

  window.addEventListener('resize', reassess, { passive: true });
  if (rmq) {
    if (rmq.addEventListener) rmq.addEventListener('change', reassess);
    else if (rmq.addListener) rmq.addListener(reassess);
  }

  enter(mode);
})();

/* ============================================================
   ROUND 14 — MAGNETIC CTAs
   Cursor-follow translate on primary buttons, desktop fine-pointer only,
   composed through --mx/--my so it never fights the existing hover/press
   transform. rAF-throttled, one delegated pointermove listener, and the
   translate is capped so the button never detaches from its shadow.
   ============================================================ */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var PULL = 0.26;        /* fraction of the cursor offset the button follows */
  var CAP_X = 11, CAP_Y = 7;
  var cur = null, qx = 0, qy = 0, ticking = false;

  function clamp(v, c) { return v > c ? c : (v < -c ? -c : v); }

  function apply() {
    ticking = false;
    if (!cur) return;
    cur.style.setProperty('--mx', qx.toFixed(2) + 'px');
    cur.style.setProperty('--my', qy.toFixed(2) + 'px');
  }

  function release(el) {
    if (!el) return;
    el.style.setProperty('--mx', '0px');
    el.style.setProperty('--my', '0px');
    el.classList.remove('mag');
  }

  document.addEventListener('pointermove', function (e) {
    var b = e.target.closest ? e.target.closest('.btn') : null;
    if (b && b.disabled) b = null;
    if (b !== cur) { release(cur); cur = b; if (cur) cur.classList.add('mag'); }
    if (!cur) return;
    var r = cur.getBoundingClientRect();
    qx = clamp((e.clientX - (r.left + r.width / 2)) * PULL, CAP_X);
    qy = clamp((e.clientY - (r.top + r.height / 2)) * PULL, CAP_Y);
    if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
  }, { passive: true });

  document.addEventListener('pointerleave', function () { release(cur); cur = null; }, true);
  window.addEventListener('blur', function () { release(cur); cur = null; });
  document.addEventListener('click', function () { release(cur); cur = null; });
})();

/* ============================================================
   ROUND 20 — MOTION & FEEL
   A. hero entrance ladder + scroll parallax on the hero photograph + a
      counter tick on the sequence.
   B. Everything is opt-in from JS: the `hero-seq` class that carries the
      hidden initial state is added BY this script, so a no-JS or
      script-error visitor never sees a blank fold.
   ============================================================ */
(function () {
  'use strict';

  /* ---- ROUND 178, backlog 173. THE REDUCED-MOTION GATE WAS ALSO EVALUATED ONCE. ----

     For 177 rounds this read

         var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

     — the SAME one-shot `matchMedia` shape round 177 fixed on `fine` two lines
     below, left alone on purpose then because reversing an entrance ladder that
     has already run is a different behaviour question from re-wiring a scroll
     listener. Measured this round with `tools/reduced_motion_probe.py` (new, the
     first instrument that can CHANGE a user preference mid-session rather than
     open two sessions with two different ones), three arms, control in the same
     run, 1440x900:

       ARM A  open no-preference -> flip to reduce
              before  hpDistinct=5  tyDistinct=5      (parallax live)
              after   hpDistinct=4  tyDistinct=1      (listener STILL RUNNING,
                                                       matrix frozen by CSS)
       ARM B  open reduce -> flip to no-preference
              before  hpDistinct=0  heroSeq=false  lit=false
              after   hpDistinct=0  heroSeq=false  lit=false   <-- THE DEFECT
       ARM C  control, no flip      5/5 before AND after, unchanged

     TWO DIFFERENT SEVERITIES, and only one of them is user-visible:

     Turning Reduce Motion ON is largely covered ALREADY, by the stylesheet, live:
     `@media(prefers-reduced-motion:reduce)` at np.css:2519 forces
     `.hero-media--life .hero-shot img{transform:scale(1.02)!important}`, so the
     composited matrix froze (tyDistinct 5 -> 1) even though JS kept writing
     `--hp` on every scroll. The user saw no motion. What leaked was WORK: a
     scroll listener still firing and an inline custom property still being
     written for a visitor who asked the OS to stop.

     Turning Reduce Motion OFF is a real, visible dead end. `if (shot && !reduced)`
     was evaluated at parse time, so for a session that STARTED reduced the `mq`
     object, the `change` listener and `wire()` were never constructed at all —
     `hpDistinct=0` before AND after the flip — and A1 never added `hero-seq`, so
     the staged entrance can never run either. That visitor gets a permanently
     static fold for the life of the session.

     THE LADDER QUESTION, ANSWERED BY MEASUREMENT AND NOT BY PREFERENCE (this is
     why A1 below is safe): `.hero-seq` WITHOUT `.lit` is authored HIDDEN
     (np.css:2430-2431), so the fear was that flipping to reduced mid-entrance
     strands a half-drawn hero. It cannot. np.css:2518 forces all three staged
     selectors `opacity:1!important;transform:none!important` under the same
     reduced-motion media block, and a CSS media query is live by construction.
     Probed in all three arms, both phases: `rvOpacityMin=1` and
     `rvTransformNonNone=0/11` EVERY time, including with `heroSeq=true` and
     `lit=true` while reduced. So A1 needs no class-removal on flip-to-reduced —
     the stylesheet already owns that direction. Do not add one.

     DO NOT COLLAPSE `isReduced()` BACK INTO A BOOLEAN READ AT LOAD TIME. The
     whole defect is a preference being answered once. Read it at USE time. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  var hero = document.querySelector('.hero');
  if (!hero) return;

  /* ---- A1. staged entrance ----
     Runs once, and can now be run LATE — a session that opened reduced and
     flipped to no-preference gets its entrance at the moment of the flip
     instead of never. `ladder()` is idempotent: `classList.add` is a no-op on a
     class already present, and the guard stops the rAF/timeout pair being
     queued twice. Flip-to-reduced deliberately does nothing here (see above). */
  var laddered = false;
  var rewire = null;          /* set by A2 when a hero photograph exists */
  function ladder() {
    if (laddered || isReduced()) return;
    laddered = true;
    hero.classList.add('hero-seq');
    /* two rAFs: the first lets the hidden state paint, the second releases it,
       so the transition actually runs instead of being collapsed away. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('lit'); });
    });
    /* hard failsafe — if anything above throws or the frame never lands, the
       fold is visible within 900ms no matter what. */
    setTimeout(function () { hero.classList.add('lit'); }, 900);
  }
  ladder();

  /* ---- A2. parallax on the hero photograph ----

     ---- ROUND 177, backlog 106. THE MEDIA GATE WAS EVALUATED ONCE, AT LOAD. ----
     For 177 rounds this read

         var fine = window.matchMedia && window.matchMedia('(min-width: 961px)').matches;
         if (shot && !reduced && fine) { ... addEventListener('scroll', ...) ... }

     — a ONE-SHOT boolean, with the scroll and resize listeners registered INSIDE
     it. So the answer to "is this a wide viewport" was frozen at the instant the
     script parsed and could never be revisited, in either direction. Measured
     with `tools/hero_parallax_probe.py` (new this round, the first instrument
     ever pointed at this driver), against a fresh-load control in the same run:

       fresh load, w1440/w1280/w1100/w980   wired=True   driveFrac 1.000
       OPENED AT 900px, RESIZED TO 1440     wired=FALSE  driveFrac 0.000  hpMax 0.0
       OPENED AT 900px, RESIZED TO 1100     wired=FALSE  driveFrac 0.000  hpMax 0.0
       OPENED AT 1440px, RESIZED TO 900     wired=True   hpMax 0.9999  (imgH 0)
       OPENED AT 1440px, RESIZED TO 760     wired=True   hpMax 1.0     (imgH 0)

     Two different failures out of one line. Narrow-then-wide is the expensive
     one: an iPad opened in portrait and turned to landscape, a laptop window
     maximised after load, a devtools panel undocked — the loudest motion on the
     highest-traffic fold of this build is DEAD for that entire session, and the
     matrix sits frozen at translate 0 / scale(1.06) no matter how far you
     scroll. Wide-then-narrow is the cheap one and still real: the driver keeps
     doing a getBoundingClientRect and a style write on every scroll frame,
     writing `--hp` onto an element that np.css:2136 has already taken out with
     `display:none!important` — 0px of visible travel for a rAF a frame.

     The fix is not to widen the condition, it is to make it LIVE. The
     MediaQueryList is kept and listened to, `wire()` is idempotent, and the
     listeners are attached and DETACHED as the query flips, so below 961px the
     cost is exactly zero rather than "cheap". On the way out `--hp` is REMOVED
     rather than set to 0, which hands the frame back to np.css's own `--hp:0`
     declaration instead of leaving an inline override that would outrank a
     future media rule.

     `lastP` is reset to -1 on every crossing on purpose: it is the "have I
     already written this value" guard, and after a viewport change the value it
     remembers describes a layout that no longer exists, so the first paint of
     the new layout must be allowed through.

     DO NOT COLLAPSE `wire()` BACK INTO A BOOLEAN READ AT LOAD TIME, and do not
     move the addEventListener calls back inside the gate — the whole defect was
     the listeners being unreachable once the gate had been evaluated. The
     `addListener` fallback is for Safari < 14, which has no
     `MediaQueryList.addEventListener`. */
  var shot = hero.querySelector('.hero-media--life .hero-shot img');
  /* ROUND 178: `&& !reduced` REMOVED FROM THIS GATE ON PURPOSE. It was the reason
     ARM B measured hpDistinct=0 after the flip — with the whole block skipped at
     parse time there was no `mq`, no `change` listener and no `wire` to call, so
     the parallax could never be revived. The preference is now consulted inside
     `wire()` instead, where it can be re-asked. `live` starts false, so a session
     that opens reduced still arms nothing and writes nothing until it flips. */
  if (shot) {
    var mq = window.matchMedia ? window.matchMedia('(min-width: 961px)') : null;
    var ticking = false, lastP = -1, live = false;
    function paint() {
      ticking = false;
      /* A rAF QUEUED BEFORE THE GATE FLIPPED MUST NOT LAND. `removeEventListener`
         cancels future callbacks, not one that is already in the frame queue, so
         the FIRST version of this round's fix leaked exactly one write on the way
         down: resize -> onScroll queues paint -> the mq `change` handler runs
         wire(), detaches and calls removeProperty -> the queued paint then fires
         and writes `--hp` straight back. `tools/hero_parallax_probe.py` caught it
         in the same round: w900 and w760 came back with an inline `--hp` of
         `0.0000` at 15 of 15 samples, frozen (so not tracking scroll — one stale
         write, not a live driver). The VALUE was harmless, being the same 0 the
         stylesheet declares; the inline override was not, because an inline
         custom property outranks any media rule that might later want the frame.
         DO NOT DELETE THIS GUARD. */
      if (!live) return;
      var r = hero.getBoundingClientRect();
      var span = r.height;
      if (span <= 0) return;
      var p = (-r.top) / span;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      if (Math.abs(p - lastP) < 0.004) return;
      lastP = p;
      shot.style.setProperty('--hp', p.toFixed(4));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(paint);
    }
    function wire() {
      /* ROUND 178: was `var fine = mq ? mq.matches : true`. The width gate and the
         preference gate are now BOTH read here, at use time, on every call — so
         either one changing re-decides the driver. Round 177's transition guard
         (`want === live`) is untouched and still does the same job: it is what
         stops a redundant `removeProperty` on a session that never armed. */
      var want = (mq ? mq.matches : true) && !isReduced();
      if (want === live) return;
      live = want;
      if (want) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        lastP = -1;
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        shot.style.removeProperty('--hp');
        lastP = -1;
      }
    }
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', wire);
      else if (mq.addListener) mq.addListener(wire);
    }
    /* ROUND 178: publish `wire` to the IIFE scope so the ONE preference listener
       registered below — outside this `if (shot)` block — can re-run it. It is
       deliberately NOT registered in here: a hero with no photograph still has an
       entrance ladder to revive, and burying the listener inside the photograph's
       block would have made the ladder's liveness depend on `shot` existing. */
    rewire = wire;
    wire();
  }

  /* ROUND 178: the second live gate, registered ONCE for the whole IIFE. Same
     `addListener` fallback for Safari <14, same reason as A2's width query. A flip
     in EITHER direction re-runs `wire()`, which re-reads the width AND the
     preference, so the two gates compose instead of one of them being frozen.

     IT DELIBERATELY DOES **NOT** CALL `ladder()`, AND THE FIRST VERSION OF THIS
     ROUND'S FIX DID — the probe caught it and the measurement overruled the
     intent. Reviving the staged ENTRANCE on a late flip reads as a defect, not a
     feature: a session that opened reduced already has its hero fully painted
     (the `@media(prefers-reduced-motion:reduce)` block forces every staged
     selector `opacity:1!important`), so adding `hero-seq` mid-session re-imposes
     the authored HIDDEN state on content the visitor is currently looking at and
     animates it back in. Measured, ARM B after the flip, sweep order ~140ms
     apart: `rvOpacityMin` 0 -> 0 -> 0 -> 0.4263 -> 0.8985, with 8 of 11 children
     carrying a transform the whole way. That is a ~700ms flash of DISAPPEARING
     content, fired by a visitor turning motion ON — exactly backwards, and worse
     than the static hero it was trying to improve.

     An entrance is a LOAD event. It does not get a second showing. The parallax
     is the opposite case and is revived on purpose: it is invisible until the
     visitor scrolls, so arming it late costs nothing and is strictly a gain. */
  if (rmq) {
    var onPref = function () { if (rewire) rewire(); };
    if (rmq.addEventListener) rmq.addEventListener('change', onPref);
    else if (rmq.addListener) rmq.addListener(onPref);
  }

  /* ---- A3. counter tick on the sequence ----
     The round-07 driver rewrites [data-seq-count] textContent on every new
     active. Watch it and pop the number so the reveal has an audible-looking
     beat instead of a silent digit swap. */
  var cnt = document.querySelector('[data-seq-count]');
  /* ROUND 178: was `if (cnt && !reduced && ...)`, i.e. the observer was either
     registered at parse time or never. Round 178 predicted this one would need an
     explicit `disconnect()`/re-`observe()` pair on flip — THAT PREDICTION WAS
     WRONG, and pleasantly so. A MutationObserver is not a driver, it is a
     notification; the cheap and fully-live fix is to always observe and re-ask the
     preference INSIDE the callback, where the answer can still change. A reduced
     visitor's observer fires and adds no class, which costs a comparison per
     mutation and nothing else. No teardown to get wrong, no listener to leak. */
  if (cnt && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      if (isReduced()) return;
      cnt.classList.add('tick');
      clearTimeout(t);
      t = setTimeout(function () { cnt.classList.remove('tick'); }, 340);
    }).observe(cnt, { childList: true, characterData: true, subtree: true });
  }
})();

/* ---- round 26: buy-box product gallery ----
   Thumb index maps 1:1 to stage-image index. No src swapping — every frame is
   already in the DOM and cross-fades on opacity, so there is no flash of an
   unloaded image and no layout shift when moving between the transparent
   packshot and a full-bleed photograph. */
(function () {
  var root = document.querySelector('[data-gallery]');
  if (!root) return;
  /* AUG 22: frames can now be <video> as well as <img> — the buy-box gallery
     renders product VIDEO media (the AI bottle loop) as an autoplaying muted
     looping playsinline element. Selector order is DOM order, so index mapping
     to thumbs is unchanged. */
  var frames = root.querySelectorAll('.bm-stage img, .bm-stage video');
  var thumbs = root.querySelectorAll('.bm-th');
  var cap = root.querySelector('.bm-cap');
  if (!frames.length || thumbs.length !== frames.length) return;

  function show(i) {
    for (var n = 0; n < frames.length; n++) {
      frames[n].classList.toggle('on', n === i);
      thumbs[n].classList.toggle('on', n === i);
      thumbs[n].setAttribute('aria-current', n === i ? 'true' : 'false');
    }
    for (var q = 0; q < frames.length; q++) {
      if (q !== i && frames[q].tagName === 'VIDEO') { try { frames[q].pause(); } catch (e) {} }
    }
    if (frames[i].tagName === 'VIDEO') {
      /* SPEED 20261028: hidden slides ship preload="none" (no bytes until tapped); arm on first show */
      if (window.__npLazyArm) { window.__npLazyArm(frames[i]); }
      else if (frames[i].preload === 'none') { frames[i].preload = 'auto'; try { frames[i].load(); } catch (e) {} }
      var pr = frames[i].play();
      if (pr && pr.catch) pr.catch(function () {});
    }
    if (cap) {
      var next = frames[i].getAttribute('data-cap') || '';
      if (next !== cap.textContent) {
        cap.style.opacity = '0';
        setTimeout(function () { cap.textContent = next; cap.style.opacity = '1'; }, 160);
      }
    }
  }
  for (var i = 0; i < thumbs.length; i++) {
    (function (n) {
      thumbs[n].addEventListener('click', function () { show(n); });
      thumbs[n].addEventListener('mouseenter', function () { show(n); });
    })(i);
  }

  /* AUG 22: autoplay resilience for the video frame. Muted+playsinline should
     autoplay everywhere, but iOS Low Power Mode and some data-saver settings
     veto the attribute — so we also nudge play() on load, on pageshow (bfcache
     restore) and when the tab becomes visible again. Rejections are swallowed:
     the poster (a real frame of the loop) is the graceful fallback. Reduced
     motion gets a still frame instead of the loop. */
  var vids = root.querySelectorAll('.bm-stage video');
  if (vids.length) {
    var rmq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var nudge = function () {
      for (var v = 0; v < vids.length; v++) {
        if (rmq && rmq.matches) { vids[v].pause(); continue; }
        /* SPEED 20261028: only the visible slide plays, and a lazy video is left alone until np-lazy-video.js has armed it */
        if (!vids[v].classList.contains('on')) { continue; }
        var lz = vids[v].getAttribute('data-np-lazy');
        if (lz && lz !== 'ready') { continue; }
        var pr = vids[v].play();
        if (pr && pr.catch) pr.catch(function () {});
      }
    };
    nudge();
    window.addEventListener('pageshow', nudge);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) nudge(); });
  }
})();

/* ============================================================
   ROUND 59 — MOTION & FEEL (axis 5)
   SECOND scroll-driven moment: the "Your pattern" band's rail.

   Scroll-LINKED, not scroll-triggered. `--rp` on the rail fill and `--pp` on
   each card are recomputed from the grid's live rect every frame, so the line
   draws forward on the way down and retracts on the way up. The one existing
   scroll-driven moment on this 18,000px page (the pinned six-actives band) is
   untouched — this driver never reads or writes `--ap`, `[data-seq]`, the
   header, or anything in the hero.

   Bail-outs, in order: no band -> no grid -> reduced motion -> viewport <=900px
   (where `.pat-grid` collapses to two columns and a four-node horizontal rail
   points at nothing). In every bail-out the `.patseq--live` class is never
   added, so the CSS falls back to the plain `.rv` -> `.rv.in` reveal that ran
   here for the previous 58 rounds. Failure mode is "no worse than round 58",
   never "invisible cards".
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-patseq]');
  if (!band) return;
  var grid = band.querySelector('[data-pat-grid]');
  var fill = band.querySelector('[data-pat-fill]');
  var nodes = Array.prototype.slice.call(band.querySelectorAll('[data-pat-node]'));
  var cards = Array.prototype.slice.call(band.querySelectorAll('[data-pat-card]'));
  if (!grid || !cards.length) return;

  /* ROUND 180, backlog 174 — held query, read at USE time. This band is a
     three-mode machine (`live` / `walk` / `off`) rather than the two-state
     enable/disable of the three drivers below, so the preference change is
     routed through `pick()` -> `setMode()` exactly like a resize: one function,
     one place where "which mode should I be in" is decided. `clearDriven()`
     already wipes `--pp`/`--np`/`--rp` on every mode change, so flipping TO
     reduce hands the cards back whole instead of freezing one mid-arrival. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  /* Where the rail's 0 and 1 sit, as fractions of viewport height measured
     against the GRID's top edge. 0.94 -> the draw starts just as the first card
     clears the fold; 0.30 -> it completes with the band comfortably on screen
     rather than already leaving it. Travel is therefore ~0.64 * vh of scroll
     (~735px at 1150px tall), which is long enough to read as a draw and short
     enough that nobody scrolls past the end of it. */
  var P_START = 0.94, P_END = 0.30;

  /* Per-card arrival window inside that progress. Same shape as the pinned
     sequence's ramp and the same round-50 arithmetic: dividing by (n-1) makes
     the LAST card START exactly on `C_END` instead of short of it.

     ---- ROUND 91: `C_END` IS DERIVED, NOT TYPED (axis 5, backlog 63) ----
     This ramp took HALF of a lesson the other two drivers on the build took in
     full, and the half it missed is the half round 55 wrote down for the pinned
     sequence, verbatim: "dividing by (n-1) ... would put card n-1's slice END
     at end+w, i.e. past the pin, and IT WOULD NEVER FULLY ARRIVE." Round 50
     fixed where the last card FIRES; round 55 fixed that its window must also
     FINISH inside the ramp. `patseq` (round 59) copied round 50 and never got
     round 55, and `seqwalk` states the same invariant explicitly one screen up
     ("W_END = 0.72, W_SPAN = 0.28; MUST sum to 1.0"). This driver was the only
     one of the three that violated it, and it was also the only one nothing had
     ever measured - which is exactly what backlog 63 said would be hiding here.

     The arithmetic, decided before any code was touched. The last card's window
     is [C_END, C_END + C_SPAN] and `p` is clamped to 1, so with C_END = 0.80 and
     C_SPAN = 0.26 the fourth card's local progress topped out at

         (1 - 0.80) / 0.26 = 0.7692   ->   easeOut = 1 - 0.2308^3 = 0.9877

     i.e. cut off at 77% of its own arrival curve, permanently, at every desktop
     height. Measured live by `tools/scroll_driver_probe.py` at 40/16/8/4px
     steps: endStateMin 0.9877 on all four - the same figure the arithmetic
     predicts, taken by a different method.

     So `C_END` is no longer a number anyone can nudge. It is DERIVED from the
     invariant the other two drivers state in prose, which makes this class of
     bug structurally impossible to reintroduce here: the last window must end
     at p = 1, therefore it must start at 1 - C_SPAN. With C_SPAN 0.26 that is
     0.74, so the per-card step becomes (0.74 - 0.05)/3 = 0.23 against a 0.26
     window - 0.03 of overlap where there was 0.01. Adjacent cards still arrive
     one at a time and in order; the fourth now lands exactly as the rail fill
     `--rp` completes, which is the moment the composition was always aimed at. */
  var C_START = 0.05, C_SPAN = 0.26;
  var C_END = 1 - C_SPAN;   /* INVARIANT: last window must END at p = 1 */

  function easeOut(t) { var u = 1 - t; return 1 - u * u * u; }

  var ticking = false, lastP = -1;
  var mode = 'off';   /* 'off' | 'live' (desktop rail) | 'walk' (phone stack) */

  function isLive() { return !isReduced() && window.innerWidth > 900; }

  /* ============================================================
     ROUND 83 — THE PHONE WALK FOR #patterns (axis 5, backlog 43b)

     THE 900px GATE WAS NOT LOWERED. `isLive()` above is untouched and the
     horizontal rail stays desktop-only, for the reason round 59 wrote down and
     round 83 re-measured: at 390px `.pat-grid` is ONE column (`gridCols`
     measured live as `342px`), so a four-node horizontal rail sitting above a
     vertical stack is a progress bar for a journey that runs the other way.
     What round 83 adds is the thing that was actually missing — a SECOND
     branch UNDER the gate, so the phone gets different geometry and different
     timing instead of NO timing. Same rule round 72 established, round 77 used
     for the shop deal, round 79 used for `easy` and round 80 used for the
     actives sequence.

     WHAT SHIPPED FOR 82 ROUNDS BELOW 900px, measured before this round touched
     anything (390px, live draft theme, four scroll depths):

       walkClass false · liveClass false · railDisplay "none" · railH 0
       --pp [null,null,null,null] · --np [null,null,null,null] · --rp null
       opacity at 25% of the band [1,0,0,0] -> at 60% [1,1,1,1], hasIn all true

     So all four cards were handed to the generic one-shot `.rv` -> `.rv.in`
     IntersectionObserver fade, and they were ALL FINISHED by 60% of the band's
     own scroll. 1,493px of phone page (band top 2,828 -> 4,320 on a 15,910px
     PDP) whose entire motion budget was spent in its first third, and zero
     driven properties at any depth. Not a missing animation — a band that
     stops responding two-thirds of the way through itself.

     WHY PER-CARD RECTS AND NOT THE GRID'S SHARED RECT: round 59's desktop path
     drives all four cards off ONE `p` taken from the grid, and it has to,
     because at 1800px the grid is a single 4-column ROW ~300px tall — one
     window there IS one moment. Stacked at 390px the same grid is 1,493px
     tall, so a shared window hands each card ~370px of scroll for 26px of lift,
     which is not slow motion, it is no motion. This is round 77's shop-deal
     reasoning (2,377px grid -> per-card rects) and the opposite of round 80's
     (~600px list -> one shared rect). The rule is the geometry, not the taste:
     a shared `p` is right when every element is on screen together, and wrong
     when they cannot be.

     WHY THE RAIL STAYS HIDDEN HERE rather than being made sticky: `#patterns`
     is a `.band-deep`, and every `.band-deep` carries `overflow:hidden` — which
     is backlog 51's sitewide trap. A `position:sticky` inside one is silently
     converted to a fixed offset against the BAND, not the viewport, while
     still reporting `position: sticky` to `getComputedStyle`. A rail that
     cannot stick would draw itself entirely off-screen above the stack, which
     is strictly worse than no rail. The cards carry the sequence on the phone.
     ============================================================ */

  /* The per-card window, as fractions of viewport height measured against the
     CARD's own top edge. 0.94 -> a card starts arriving as it clears the fold;
     0.52 -> it is fully arrived while it sits comfortably mid-screen, not as it
     leaves. Travel is 0.42 * vh (~354px at 844px tall) against a ~373px card
     pitch, so at most two cards are ever in flight and each one owns a
     readable stretch of scroll. W_FLOOR is the collapse guard, same shape as
     round 77's P_FLOOR and round 80's L_FLOOR. */
  var W_IN = 0.94, W_OUT = 0.52, W_FLOOR = 0.22;

  /* ---- ROUND 134: W_CAP, THE CEILING (axis 5, backlog 105) ----------------
     `W_FLOOR` above guards ONE direction. It stops the window collapsing to
     nothing, and nothing stopped it GROWING without bound — which is the
     defect, and it is a slope, not a stop. `travel` was purely `vh * 0.42`
     while the distance actually moved is a fixed 26px (the `.patseq--walk`
     translate), so the speed of this band is `26 / (k * vh)`: THE TALLER THE
     PHONE, THE SLOWER THE MOTION, forever. Measured on the live draft before
     this line existed (`captures/round-134-patseq-before.json`):

         m667   0.13271   span 192      (192/667 = 0.2879)
         m844   0.10274   span 248      (248/844 = 0.2938)
         m1000  0.08382   span 304      (304/1000 = 0.3040)

     Round 123's floor for a no-neighbour layout is 0.10 travel-per-scroll, so
     the band crosses it at vh ~= 849px: m844 clears by 2.7% (the bracket edge
     round 104 warned about) and m1000 fails outright at 16% under.

     That the floor APPLIES here at all is what round 134 had to settle first.
     `patseq`'s phone layout is ONE COLUMN — `gridTemplateColumns: 342px`,
     `offsetLeft` [24,24,24,24] on all four cards. Backlog 105 had it filed as
     "2 distinct left edges" since round 126 and that reading was an INSTRUMENT
     artefact: the rule above this one scales the card
     (`scale(calc(.985 + var(--pp,0) * .015))`), and `getBoundingClientRect()`
     reports the POST-transform box, so a card mid-fade at `--pp 0.1783` sat
     2.1077px right of its own layout position. Predicted `(1 - .987674) *
     342 / 2 = 2.1077px`; measured `26.1077 - 24 = 2.1077px`. Forcing `--pp:1`
     collapsed the reading from 2 columns to 1. See
     `tools/column_count_probe.py`, which measures `offsetLeft` and keeps the
     old ruler beside it so the artefact stays reproducible.

     THE CEILING IS DERIVED, NOT TYPED — same discipline as `C_END` above:

         probe's 0.01->0.99 band covers 0.98 * 26px            = 25.48px
         worst observed span/window ratio (m1000: 304/420)     = 0.7238
         target speed: 0.12, a deliberate 20% margin over 0.10
         W_CAP = 25.48 / (0.12 * 0.7238)                       = 293.4 -> 292

     20% of margin and not 1% because the sweep quantises `span` to 8px, which
     is ~3.8% of a 210px span — a fix that landed on 0.101 could be flipped by
     the sampler alone, which is not a fix, it is a coin.

     ORDER MATTERS: floor first, then ceiling. They can only disagree above
     vh = 292/0.22 = 1327px (a 900px-wide tablet in portrait), and there the
     ceiling must win — 292px of window is nowhere near the collapse `W_FLOOR`
     exists to prevent, so capping it costs nothing and un-capping it would
     re-open exactly this bug on the tallest viewports.

     m667 is BELOW the cap (0.42 * 667 = 280.1px) and is therefore untouched by
     construction. It is the control, and it is deterministic, not lucky. */
  /* ---- ROUND 138: THE CEILING RE-DERIVED FOR T = 38 (axis 5, backlog 117) --
     Everything above is round 134's and every word of it still holds. What
     changed is the INPUT, not the method: `.patseq--walk .pat.rv`'s translate
     is now 38px, not 26px (np.css, see the round-138 comment there), so
     `25.48` is no longer what the probe's 0.01->0.99 band covers.

         probe's 0.01->0.99 band covers 0.98 * 38px            = 37.24px
         worst observed span/window ratio (m1000: 304/420)     = 0.7238
         target speed: 0.12, the same deliberate 20% margin
         W_CAP = 37.24 / (0.12 * 0.7238)                       = 428.744 -> 428

     Rounded DOWN, same as 293.359 -> 292: rounding a ceiling down keeps the
     margin, rounding it up spends margin that the 8px sampler quantum already
     owns.

     ---- AND THAT DERIVATION IS THE WRONG SHAPE. Measured, round 138. --------
     `span = ratio * travel` is a proportion through the origin, and the AFTER
     sweep falsified it at the one stop that can tell the two models apart.
     m667's window is below BOTH caps, so round 134's model predicts its span
     cannot move when only the translate changes. It moved, 192 -> 184, and
     three same-code control runs reproduced 184 exactly - deterministic, not
     sampler noise.

     THE MECHANISM IS A FEEDBACK LOOP IN `walkPaint` ITSELF, four lines below:
     `local` is computed from `cards[i].getBoundingClientRect().top`, and a
     rect is the POST-TRANSFORM box (backlog 105/114). So the card's own
     translate is inside its own progress term:

         cr.top = layoutTop + (1 - pp) * T
         local  = (vh*W_IN - layoutTop - (1 - pp) * T) / travel

     A card that has not arrived yet is sitting T px LOWER than its layout
     slot, which holds `local` down and delays the start of its own crossing;
     by the end (pp = 1) the offset is zero and the finish is unmoved. So the
     translate SHORTENS the measured span, and the true law is affine in the
     window with a negative intercept proportional to T:

         span = K * travel - 0.98 * T,     K = 0.77785 (6-point fit)

     Fitted over all six phone measurements (three at T = 26, three at T = 38,
     across three different windows) the affine law's RMS residual is 1.88px
     against the proportional law's 3.05px, and every affine residual is inside
     the 8px sampler quantum while the proportional law is 6.23px out at m667.
     `captures/round-138-span-law-derivation.json` holds the table.

     Solving the SAME 0.12 target against the corrected law:

         0.98T / (K * W_CAP - 0.98T) = 0.12
         W_CAP = 0.98T * (1 + 1/0.12) / K = 446.8   (440.0 - 450.1 over the
                                                     per-point spread of K)

     `W_CAP` IS DELIBERATELY LEFT AT 428 ANYWAY, and that is a decision, not an
     oversight. 428 is BELOW the corrected range, so it is the conservative
     end: at the cap the corrected law gives span 295.7 and tps 0.12595, over
     the 0.12 floor under every K in the measured spread. Raising it to 447
     would buy a little more `driveFrac` on viewports taller than 1019px - of
     which this build has none; the tallest swept stop is m1000, whose 420px
     window is under both numbers, so NOTHING SHIPPED TODAY WOULD MOVE. Moving
     a constant by 19px on a three-window fit, to change behaviour at no stop
     that exists, is churn. It is filed as backlog 118 with the K spread, to be
     spent by a round that first measures K directly instead of fitting it.

     WHY THIS IS THE POINT OF THE ROUND, not a side effect. 428 > 0.42 * 1000 =
     420, so at m1000 the cap STOPS BINDING and the window returns to its full
     pre-134 width — 420px instead of 292px — which is how `driveFrac` gets
     bought back (0.3601 -> ~0.4277) while the SPEED still goes UP, because the
     speed is now paid for by the distance instead of by the window. Round 134
     could only trade one against the other. It is not "the cap was deleted":
     the ceiling is intact and still enforces 0.12, it simply binds above
     vh = 428 / 0.42 = 1019px now instead of above 695px. On a viewport that
     tall, travel clamps to 428 and tps = 37.24 / (0.7238 * 428) = 0.1202,
     still over the floor. That is the whole job of this constant and it is
     still doing it.

     ORDER STILL MATTERS, and the floor/ceiling crossover moved with the cap:
     they can now only disagree above vh = 428 / 0.22 = 1945px. Ceiling still
     wins there, for round 134's reason unchanged.

     m667 is still the control: 0.42 * 667 = 280.1px, below 292 and below 428,
     so its window is untouched by BOTH derivations and any change in its speed
     is attributable to the translate alone. That is what makes it the clean
     read on this round. */
  /* ---- ROUND 143: K MEASURED DIRECTLY, AND IT WAS NEVER EMPIRICAL ---------
     Backlog 118's own instruction was "spend only in a round that measures K
     directly instead of fitting it". Measured, and the answer is that K is not
     a property of this build at all — it is a property of `easeOut` and of the
     band the probe measures over, and its closed form was ALREADY IN THIS FILE
     610 lines above, written by round 128 for `W_CARD`:

         "0.781212 is the easeOut 0.01 -> 0.99 crossing fraction,
          1-0.99**(1/3) to 1-0.01**(1/3), which is what the probe measures"

     Derived rather than quoted, so no round has to trust the sentence:
     `easeOut(t) = 1-(1-t)^3`, so `L(p) = 1-(1-p)^(1/3)`, and the feedback loop
     the round-138 block above identified puts the card's own translate inside
     its own progress term. Solving for the scroll position at a given `--pp`:

         scrollY(p) = travel*L(p) + (1 - p)*T + const
         span       = travel*(L(.99) - L(.01)) - 0.98*T
         K          = 0.99^(1/3) - 0.01^(1/3) = 0.78121202   EXACT

     The affine law round 138 discovered is right in every respect except that
     its slope did not need fitting and its residual was the INSTRUMENT.

     WHY THE FIT CAME BACK LOW (0.77785), MEASURED not guessed. The probe
     snapped each 0.01 / 0.99 crossing to the first SAMPLE at or past the
     threshold. That floor puts a uniform 0-to-one-quantum error on each end
     independently, so it does not bias a single span in a fixed direction —
     it adds ~half-a-quantum of NOISE to every one of them, and a two-parameter
     fit with the intercept pinned at 0.98*T has no way to tell that noise from
     a shallower slope. 0.77785 is one draw from it. Round 143 interpolated the
     crossings linearly between the bracketing samples
     (`tools/scroll_driver_probe.py::_cross`, published beside the incumbent
     floored ruler, never replacing it) and re-measured the SAME six phone
     stops at the SAME step 8:

         stop        window   spanFloored  spanInterp   K floored   K interp
         m390x667    280.14       184        182.5415    0.789748   0.784542
         m390x760    319.20       208        211.2866    0.768296   0.778592
         m390x844    354.48       240        240.7989    0.782103   0.784357
         m390x920    386.40       264        264.8964    0.779607   0.781927
         m390x1000   420.00       288        289.2711    0.774381   0.777407
         m744x1133   428.00       296        296.8322    0.778598   0.780543

         floored  mean 0.778789  sd 0.006600   <- round 138's 0.77785, reproduced
         interp   mean 0.781228  sd 0.002686   <- closed form, error +0.000016

     Interpolation did not move the mean by much. It HALVED THE SCATTER, and
     that is the whole finding: the fit was not measuring the site, it was
     measuring the ruler. `captures/round-143-K-before.json` holds the run.

     SO THE CEILING, RE-DERIVED IN CLOSED FORM WITH NO SPREAD LEFT IN IT:

         0.98T / (K * W_CAP - 0.98T) = 0.12
         W_CAP = 0.98 * 38 * (1 + 1/0.12) / 0.78121202 = 444.9155 -> 444

     Rounded DOWN, same discipline as 293.4 -> 292 and 428.744 -> 428: at 444
     the span is 309.62 and tps is 0.12028, still over the 0.12 target; at 445
     it is 0.11997 and the target is MISSED. 444 is not a preference, it is the
     last integer that clears. Round 138's filed range was 440.0-450.1 and 444
     lands inside it, so this corrects the fit rather than refuting it.

     AND THIS ONE DOES MOVE SOMETHING, which is what round 138 could not say.
     Round 138 declined the change on "the tallest swept stop is m1000, so
     nothing shipped today would move". m1000 is the SWEEP's ceiling, not the
     DEVICE space's: `isWalk()` gates on width <= 900, and 744x1133 (iPad mini
     portrait) and 810x1080 (iPad Air portrait) are both inside that gate and
     both above the cap's binding height. At 744x1133 the window goes 428 ->
     444, the measured span goes 296.83 -> 309.6, and tps comes down from
     0.12534 to 0.12028 — the band gets 4.2% more scroll to move in on the
     exact viewports where the cap is the only thing setting its speed.

     WHAT MUST NOT MOVE, and was checked rather than assumed: every stop with
     vh <= 1057 resolves `0.42*vh` below BOTH caps, so m667/m760/m844/m920/
     m1000 and all seven incumbent stops must read byte-identical spans before
     and after. They do. ------------------------------------------------- */
  var W_CAP = 444;   /* px. DERIVED above from the 0.12 working floor AT T = 38
                        and K = 0.78121202, which is CLOSED FORM, not a fit —
                        it is `0.99^(1/3) - 0.01^(1/3)`, the cubic ease's
                        0.01->0.99 crossing fraction, and it will not change
                        unless `easeOut` does. COUPLED to
                        `.patseq--walk .pat.rv`'s translate in np.css — if that
                        38px changes, this is wrong until it is re-solved in
                        the same closed form. Do not "restore" it to 292 (the
                        T = 26 answer) or to 428 (the fitted-K answer, 3.8%
                        conservative), do not round it up to 445 (tps 0.11997,
                        under the target), and do not delete it as redundant. */

  function isWalk() { return !isReduced() && window.innerWidth <= 900; }

  function walkPaint() {
    ticking = false;
    var vh = window.innerHeight || 1;
    var travel = vh * (W_IN - W_OUT);
    if (travel < vh * W_FLOOR) travel = vh * W_FLOOR;
    if (travel > W_CAP) travel = W_CAP;

    for (var i = 0; i < cards.length; i++) {
      var cr = cards[i].getBoundingClientRect();
      var local = (vh * W_IN - cr.top) / travel;
      local = local < 0 ? 0 : (local > 1 ? 1 : local);
      cards[i].style.setProperty('--pp', easeOut(local).toFixed(4));
      /* The node is hidden on the phone (the rail is `display:none` here), but
         it is written anyway so a resize up past 900px hands the desktop rail a
         correct head position instead of four dark dots until the next scroll. */
      if (nodes[i]) {
        var np = local <= 0 ? 0 : easeOut(Math.min(1, local * 1.8));
        nodes[i].style.setProperty('--np', np.toFixed(4));
      }
    }
  }

  function paint() {
    ticking = false;
    /* ROUND 83: this guard used to read `if (!live) return;`. The `live`
       boolean was the old two-state (on/off) flag; the driver now has THREE
       states and `mode` is the single source of truth. Leaving the old flag
       here would have made the DESKTOP rail dead on arrival, because nothing
       sets `live` any more. Caught by reading the diff, not by a probe. */
    if (mode !== 'live') return;

    var r = grid.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    var a = vh * P_START, b = vh * P_END;
    var p = (a - r.top) / (a - b);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    /* Skip repaints the eye cannot see; the rail is 1100px wide, so 0.3% is
       sub-pixel. Same guard the hero parallax uses. */
    if (Math.abs(p - lastP) < 0.003) return;
    lastP = p;

    if (fill) fill.style.setProperty('--rp', p.toFixed(4));

    var n = cards.length;
    var step = n > 1 ? (C_END - C_START) / (n - 1) : 0;
    for (var i = 0; i < n; i++) {
      var local = (p - (C_START + step * i)) / C_SPAN;
      local = local < 0 ? 0 : (local > 1 ? 1 : local);
      var e = easeOut(local);
      cards[i].style.setProperty('--pp', e.toFixed(4));
      /* The node lights on the same clock as its card but snaps harder, so the
         rail head reads as a moving point rather than four slow glows. */
      if (nodes[i]) {
        var np = local <= 0 ? 0 : easeOut(Math.min(1, local * 1.8));
        nodes[i].style.setProperty('--np', np.toFixed(4));
      }
    }
  }

  /* One rAF, two driven branches. `live` and `walk` are BRANCHES of the same
     system — same cards, same `--pp`, same easing, same `.rv` override — and
     only the geometry and the source of progress differ. `off` (reduced motion)
     is the only path that still hands the cards to the CSS. */
  function frame() {
    if (mode === 'live') { paint(); return; }
    if (mode === 'walk') { walkPaint(); return; }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  /* Round 55's lesson, and the reason this is one function rather than two
     `disable()`s: clear EVERY driven custom property on any mode change, so a
     value frozen mid-arrival by the old branch can never outlive it and be read
     as the new branch's output. */
  function clearDriven() {
    cards.forEach(function (c) { c.style.removeProperty('--pp'); });
    nodes.forEach(function (nd) { nd.style.removeProperty('--np'); });
    if (fill) fill.style.removeProperty('--rp');
  }

  function setMode(next) {
    if (next === mode) return;
    if (mode === 'off') window.addEventListener('scroll', onScroll, { passive: true });
    mode = next;
    band.classList.toggle('patseq--live', next === 'live');
    band.classList.toggle('patseq--walk', next === 'walk');
    clearDriven();
    lastP = -1;
    if (next === 'off') {
      window.removeEventListener('scroll', onScroll);
      /* hand the cards back to the class-toggle path */
      cards.forEach(function (c) { c.classList.add('in'); });
      return;
    }
    frame();
  }

  function pick() { return isLive() ? 'live' : (isWalk() ? 'walk' : 'off'); }

  setMode(pick());

  /* ROUND 180 — one handler, two events. */
  function reassess() {
    var next = pick();
    if (next !== mode) { setMode(next); }
    else { lastP = -1; onScroll(); }
  }

  window.addEventListener('resize', reassess, { passive: true });
  if (rmq) {
    if (rmq.addEventListener) rmq.addEventListener('change', reassess);
    else if (rmq.addListener) rmq.addListener(reassess);
  }
})();

/* ============================================================
   ROUND 61 — CONVERSION ARCHITECTURE (axis 3)
   The "Your pattern" band's four cards, as a real single-select control.

   Round 60 fixed this band's over-promising heading by LOWERING the promise
   ("find out which one is yours" -> "it's usually one of these four"). This
   raises the delivery instead: the cards are now a WAI-ARIA radiogroup, and
   the selection is not decorative — it is written into the buy box's
   `properties[Pattern]` line-item input, so it rides the add-to-cart into the
   order. That is what makes the Discovery Kit's "Pattern-personalized welcome
   card" claim true; before this round the site sold a personalized card and
   never asked the visitor which pattern they were.

   Three deliberate decisions:

   1. The choice is mirrored into `sessionStorage`, because the PDP
      (`templates/product.json`) renders the buy box but NOT the patterns band.
      Without the mirror, a visitor who picks a pattern on the home page and
      then navigates to the product page silently loses it at the only moment
      it matters. `syncBuybox()` therefore runs on load, independently of
      whether the band exists on this page.
   2. The hidden input ships `disabled` from Liquid and is only enabled on a
      real selection. A disabled control is not serialised into FormData, so
      "never picked a pattern" produces NO property rather than an empty one.
   3. Nothing here writes `transform` or `opacity` on a `.pat`. Those two are
      owned per-frame by the round-59 rail driver above; the selected state is
      a class the CSS renders with box-shadow/border/background only. Round
      59's lesson 2 ("composed transforms, not competing ones") applied by
      simply not competing.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'np_pattern';

  function store(v) {
    try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {}
  }
  function stored() {
    try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }

  /* Push the current pattern into every buy box on the page: the hidden
     line-item property, and the visible echo that tells the visitor their
     choice is actually travelling with the purchase. */
  function syncBuybox(name) {
    var inputs = document.querySelectorAll('[data-pattern-prop]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].value = name || '';
      inputs[i].disabled = !name;
    }
    var echoes = document.querySelectorAll('[data-pattern-echo]');
    for (var j = 0; j < echoes.length; j++) {
      var b = echoes[j].querySelector('[data-pattern-echo-name]');
      if (b) b.textContent = name || '';
      if (name) echoes[j].removeAttribute('hidden');
      else echoes[j].setAttribute('hidden', '');
    }
  }

  /* Runs on every page, band or no band — this is what carries a home-page
     choice onto the PDP. */
  syncBuybox(stored());

  /* ROUND 62: this used to bind exactly ONE radiogroup (the home page's
     #patterns band). The product page now renders a second one inside the buy
     box, for the visitor who lands cold on the PDP from an ad and would
     otherwise never be asked. Rather than fork the selector, the module now
     drives EVERY `[data-pat-grid][role=radiogroup]` on the page off the same
     code path.

     The one real change in shape: selection is keyed by NAME, not by index.
     Two groups in different DOM with different orders must never be able to
     drift; a name is the same fact on both. */
  var groups = [];
  var allGrids = document.querySelectorAll('[data-pat-grid][role="radiogroup"]');
  for (var gi = 0; gi < allGrids.length; gi++) {
    var cds = Array.prototype.slice.call(allGrids[gi].querySelectorAll('[data-pat-card]'));
    if (cds.length) groups.push({ grid: allGrids[gi], cards: cds });
  }
  if (!groups.length) return;

  var cta = document.querySelector('[data-pat-cta]');
  var ctaBase = cta ? (cta.getAttribute('data-pat-cta-base') || cta.textContent).trim() : '';

  /* Visual/ARIA state only. Split out from select() so a same-session restore
     can repaint without re-storing or re-syncing what is already correct. */
  function paint(name) {
    for (var g = 0; g < groups.length; g++) {
      var cards = groups[g].cards, hit = -1;
      for (var k = 0; k < cards.length; k++) {
        var on = !!name && cards[k].getAttribute('data-pattern') === name;
        if (on) hit = k;
        cards[k].classList.toggle('pat--sel', on);
        cards[k].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      /* Roving tabindex: exactly one tab stop per group, which is what a
         radiogroup is supposed to be in the tab order. A group that does not
         contain the selected name keeps its stop on the first card. */
      var stop = hit < 0 ? 0 : hit;
      for (var t = 0; t < cards.length; t++) {
        cards[t].setAttribute('tabindex', t === stop ? '0' : '-1');
      }
    }
    if (cta && ctaBase) cta.textContent = name ? ctaBase + ' · ' + name : ctaBase;
  }

  function select(name, focusEl) {
    paint(name);
    store(name);
    syncBuybox(name);
    if (focusEl) focusEl.focus();
  }

  for (var b = 0; b < groups.length; b++) {
    (function (grp) {
      grp.grid.addEventListener('click', function (e) {
        var card = e.target.closest('[data-pat-card]');
        if (!card || grp.cards.indexOf(card) < 0) return;
        select(card.getAttribute('data-pattern') || '', null);
      });

      grp.grid.addEventListener('keydown', function (e) {
        var card = e.target.closest('[data-pat-card]');
        if (!card) return;
        var cards = grp.cards, i = cards.indexOf(card), n = cards.length, next = -1;
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        else if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') next = i;
        else return;
        e.preventDefault();
        select(cards[next].getAttribute('data-pattern') || '', cards[next]);
      });
    })(groups[b]);
  }

  /* Restore a same-session choice so scrolling back up, or coming back from
     the PDP, does not show an unselected control that contradicts the buy box.
     syncBuybox(stored()) already ran above, so this only repaints. */
  var was = stored();
  if (was) paint(was);
})();

/* ============================================================
   ROUND 63 — legal documents (Refunds / Shipping / Terms)
   The panels open and close on :target alone, so the terms are
   readable with JS off. This block is enhancement only:
   scroll lock, Escape to close, and focus that goes to the panel
   and comes back to the link that opened it.
   ============================================================ */
(function () {
  'use strict';
  var layer = document.querySelector('.lgl-layer');
  if (!layer) return;

  var CLOSED = 'legal-closed';           /* an id that deliberately does not exist */
  var root = document.documentElement;
  var opener = null;

  function current() {
    var id = (location.hash || '').slice(1);
    if (!id) return null;
    var el = document.getElementById(id);
    return el && el.classList.contains('lgl') ? el : null;
  }

  /* Lock the ROOT element, never <body>. Round 57: giving <body> a non-visible
     overflow makes it a scroll container and silently kills position:sticky for
     every descendant, which is how the header shipped non-sticky for 56 rounds.
     Locking the root stops the page scrolling without changing what <body> is. */
  function sync() {
    var panel = current();
    root.classList.toggle('lgl-lock', !!panel);
    if (panel) {
      var x = panel.querySelector('.lgl-x');
      /* the body starts at the top every time a document is opened */
      var body = panel.querySelector('.lgl-body');
      if (body) body.scrollTop = 0;
      if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
    } else if (opener) {
      try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      opener = null;
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-lgl]');
    if (a) opener = a;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!current()) return;
    e.preventDefault();
    location.hash = CLOSED;
  });

  window.addEventListener('hashchange', sync);
  sync();
})();

/* ============================================================
   ROUND 71 — MOTION & FEEL (axis 5), backlog 19.
   THIRD scroll-driven moment: the #pathway dose ledger.

   The problem this fixes, measured before it was written: the home page is
   15,000px and the 7,064px between the pinned actives band (ends y=3,839) and
   the #patterns rail (starts y=10,903) carried only one-shot `.rv` reveals -
   every element faded up once on entry and then sat inert for the rest of the
   scroll. gruns.co keeps responding to the wheel across the same stretch.

   What it does: each ingredient card's dose chip COUNTS from 000 to its real
   printed number across its own slice of the section's scroll travel, while a
   ledger above the grid tallies the running total to the label's real sum. It
   is scroll-LINKED, not scroll-triggered - `--gp` per card and `--tp` on the
   ledger fill are recomputed from the grid's live rect every frame, so the
   numbers count back DOWN on the way up.

   It shares the round-59 rail's arithmetic and its bail-out ladder, and it
   invents no second animation system. It never reads or writes `--ap`,
   `[data-seq]`, `--rp` / `--pp` / `--np`, the header, or anything in the hero.

   Bail-outs, in order: no section -> no grid/cards -> reduced motion ->
   viewport <=900px. In every bail-out `.pathseq--live` is never added, so the
   CSS falls straight back to the `.rv` / `.rv-stagger` reveal that ran here
   for 70 rounds, with every chip at its full printed value. Failure mode is
   "round 70", never "cards at opacity 0" and never "a chip stuck on 000".
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-pathseq]');
  if (!band) return;
  var grid = band.querySelector('[data-path-grid]');
  var cards = Array.prototype.slice.call(band.querySelectorAll('[data-path-card]'));
  if (!grid || !cards.length) return;

  var chips = cards.map(function (c) { return c.querySelector('[data-dose-mg]'); });
  var fill = band.querySelector('[data-path-fill]');
  var totalEl = band.querySelector('[data-path-total]');

  /* Doses and the total come out of the DOM, which got them out of the theme
     blocks. Nothing here is typed, so a dose edit moves the ledger with it. */
  /* 2026-08-25 - the real label carries fractional amounts (2.5 mg flower
     extracts), so this odometer parses FLOAT, not int. parseInt turned 2.5 into
     2 and rendered "002 mg" on a card whose own label says 2.5 mg. */
  var doses = chips.map(function (ch) {
    return ch ? (parseFloat(ch.getAttribute('data-dose-mg')) || 0) : 0;
  });
  var doseDec = doses.map(function (d) { return Math.abs(d - Math.round(d)) > 1e-9; });
  var rest = chips.map(function (ch) {
    /* " mg" - keep whatever unit string the theme actually printed. */
    return ch ? String(ch.textContent).replace(/^\s*[\d.,]+/, '') : '';
  });
  var origin = chips.map(function (ch) { return ch ? ch.textContent : ''; });
  var totalMg = totalEl ? (parseFloat(totalEl.getAttribute('data-total-mg')) || 0) : 0;
  var totalDec = Math.abs(totalMg - Math.round(totalMg)) > 1e-9;
  var originTotal = totalEl ? totalEl.textContent : '';

  /* ROUND 180, backlog 174 — held query, read at USE time. Same defect and same
     fix as the shop grid below, and this one is the WORST of the five in the
     forward direction: `np.css` has no `@media(prefers-reduced-motion:reduce)`
     rule for `pathseq--live` at all, and `--gp` feeds `transform:translateY(...)`
     DIRECTLY at np.css:3780 — not a transition, not an animation — so the global
     `.001ms` clamp at np.css:2076 never touched it. Measured pre-fix: after the
     visitor turns Reduce Motion ON this band still produced matsDistinct=3, i.e.
     real motion, not just leaked work. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  /* Same window as the round-59 rail, measured against the GRID's top edge:
     0.94 -> counting starts as the first row clears the fold; 0.30 -> it
     finishes with the whole grid comfortably on screen instead of leaving it.
     ~0.64 * vh of travel (~735px at 1150px tall). */
  var P_START = 0.94, P_END = 0.30;
  /* ROUND 72 - the phone window, and the reason there has to be a second one.
     Round 71 gated this driver off entirely at <=900px, which left a 20,350px
     phone home page with ZERO scroll-linked motion while desktop had three
     driven systems. The ledger is the one of those three with no layout reason
     to bail: it is a single flex row and the cards simply stack to one column.
     What actually breaks on a phone is the TIMING. The window above is a fixed
     0.64 * vh (540px at 844px tall) measured off the grid's TOP edge, and the
     stacked grid is 2,670px tall - so the ledger would hit 800 / 800 mg with
     four cards still below the fold, which is a counter that lies.
     On a stacked layout the END of the window is therefore tied to the grid's
     BOTTOM edge: counting completes when the grid bottom reaches P_TAIL * vh,
     i.e. with the last card on screen. Measured live at 390x844 - grid top
     11,111, height 2,670 - travel runs scrollY 10,318 -> 12,954 (2,636px), and
     every card ends fully lit while its own top sits between -50px and +382px
     of the viewport top.
     The branch keys on WIDTH, not on "is the grid taller than the window."
     That is deliberate: the DESKTOP grid is also taller than its window (921px
     vs 736px), so a height-keyed rule would silently re-time desktop and break
     round 71's measured 264 / 481 / 707 / 800 stops. Desktop must not move. */
  var P_TAIL = 0.98, STACK_W = 900;
  /* ROUND 104, backlog 80 - THE DESKTOP TRAVEL FLOOR. Same shape as round
     101's `W_FLOOR` on shopseq and it is arithmetic, not taste.
     The desktop window is `vh * (P_START - P_END)` = 0.64 * vh, so the travel
     is PROPORTIONAL to viewport height while `#pathway` is a FIXED 1454.86px
     tall (measured at every stop, invariant in height). The probe's
     `driveFrac` is drive / (bandH + vh), so it must fall as vh falls:
     0.2949 (d1400) -> 0.2677 -> 0.2313 -> 0.2101 (d760) against a 0.20 floor.
     No desktop stop below 760px of height had ever been swept. Six were, and
     the model `driveFrac = k*vh/(1454.86+vh)` predicted all six to a worst
     error of 0.0022: 720 -> 0.2030, 700 -> 0.1970, 680 -> 0.1955,
     640 -> 0.1877, 620 -> 0.1853, 600 -> 0.1797. FIVE OF SIX FAILED.
     The crossing is vh ~= 723px - i.e. every windowed/laptop desktop viewport
     shorter than that ran a driver the gate would have called dead.
     486 is BRACKETED, not chosen. Lower bound 462: below it the gate fails at
     the top of the binding region (vh 759). Upper bound: at 486 the `max(0,..)`
     visibility clamp below stays inactive down to vh = 517 (486/0.94), so the
     window always ends with the grid top still on screen. And 486 < 486.4 =
     0.64*760, so the floor CANNOT bind at or above 760 and the whole published
     seven-stop series is untouched to the digit.
     ANCHORED AT ENTRY, per round 101's contract: `a` (0.94*vh, the grid top
     clearing the fold) never moves; only the END is pushed later. Widening at
     the entry end would put drive above the fold where `driveFrac` counts it
     and nobody can see it. The `max(0, ...)` is the visibility half of that
     same contract: the window may never finish AFTER the grid top has left the
     top of the viewport, so drive is never counted off-screen. That clamp
     binds below vh 517 and makes travel 0.94*vh there, which still holds the
     gate down to vh = 422 (0.8886*vh/(1454.86+vh) >= 0.20). Below 422px of
     desktop height the gate fails by design and visibly, rather than passing
     on motion nobody can see. DESKTOP ONLY - the stacked branch is already
     0.62-0.64 at every phone height incl. five below m667, swept this round. */
  /* ---- ROUND 107, backlog 82 - 486 -> 610. THE FLOOR IS RAISED ON PURPOSE ----
     Everything round 104 wrote above is still true; what changed is that 486
     was chosen to be INVISIBLE (486 < 486.4 = 0.64*760, so it could not bind at
     or above 760 and no published number moved). That safety had a price, and
     the price was the whole point of backlog 82: it parked `pathway`'s global
     desktop minimum at 0.2101 against a 0.20 gate - 0.0101 of clearance, the
     thinnest number on the entire build. A floor set exactly at its own
     no-op boundary is round 104's own lesson 5 shape: a value pressed flat
     against the edge of the bracket it was supposed to sit inside.
     THE MINIMUM IS AT THE JUNCTION, and that is derivable rather than swept.
     Above vh = F/0.64 the floor is inactive and driveFrac RISES with vh;
     between F/0.64 and F/0.94 travel is the constant F so driveFrac RISES as
     vh FALLS. Both branches rise away from vh = F/0.64, so the junction IS the
     minimum, and min(F) = k*F / (1454.86 + F/0.64) with k = 0.957 measured
     (not assumed) off round 104's six shipped desktop-low cells, where it
     reads 0.9560-0.9581. That model returns 0.2101 at F=486 - the published
     d760 number to four decimals - before it was used to pick anything.
     Backlog 82 filed "560 -> ~0.2424". THE FILED NUMBER WAS WRONG: 560 gives
     0.2300. Solving min(F) = 0.2424 gives F = 609.9. Second deferred item in
     two rounds whose filed number did not survive being re-measured.
     610 IS BRACKETED, NOT CHOSEN. Lower bound 486.4 (= 0.64*760): at or below
     it the floor cannot bind at d760 and the fix is a literal no-op. Upper
     bound 736.0 (= 0.64*1150): at or above it the floor binds at d1150 and
     re-times a SECOND published stop round 104 deliberately left alone. 610
     sits at 0.497 of that bracket, 25.4% above the lower bound.
     TWO PUBLISHED NUMBERS MOVE, BOTH UP, AND THAT IS AUTHORISED, NOT SILENT:
     d760 0.2101 -> 0.2636 and d900 0.2313 -> 0.2479. d1150 and d1400 are
     unfloored and byte-identical; all three phone stops are on the stacked
     branch and cannot see this constant at all. Backlog 82 required the
     incumbent series be RE-PUBLISHED rather than tweaked, and round 107's
     QUALITY.md re-publishes all seven.
     WHAT DOES NOT MOVE: the `max(0, a - H_FLOOR)` visibility clamp is
     untouched, so travel still can never exceed 0.94*vh and the window still
     always ends with the grid top on screen. F does not appear in that branch
     at all, so the "gate fails below vh ~= 416, by design and visibly" line
     above is INVARIANT under this change - raising the floor cannot move that
     crossing. What it does move is the clamp's activation height, 486/0.94 =
     517 -> 610/0.94 = 649, which is why vh 600/620/640 read the clamped
     0.94*vh travel rather than the floored 610.
     A HALF FIX WAS SHIPPED AND SWEPT FIRST, AND IT CAME BACK GREEN. F=548
     passes the gate at every stop (junction 0.2257, d760 0.2355, d620 0.2510,
     `clean: true`) - `captures/round-107-control-halffix.json`. So the 0.20
     gate CANNOT distinguish a half fix from a full one on this driver. A green
     run is not evidence this value is right; only the re-published series is.
     Do not "verify" a future change to this constant by checking `clean`. */
  /* ---- ROUND 118, backlog 94 - THE `0` IN THE CLAMP WAS THE WRONG BOUND ----
     Round 115 swept below the clamp crossing for the first time and found the
     gate failing: at w1800 the desktop `driveFrac` reads 0.1814 at vh 360 and
     0.1948 at vh 400 against a 0.20 floor, bracketed 415 fails / 420 passes.
     Round 104 had already predicted that region and ACCEPTED it, 14 rounds
     earlier and 50 lines above: "Below 422px of desktop height the gate fails
     by design and visibly, rather than passing on motion nobody can see."
     So backlog 94 is a RE-FILING of a documented decision, and the only
     question worth a round is whether the decision's PREMISE is true.
     IT IS NOT, AND IT IS FALSE ON THE SHIPPED BUILD - MEASURED, NOT ARGUED.
     `tools/pathway_visibility_probe.py` puts the grid's top edge at the
     window's own end and reads every `[data-dose-mg]` rect off the live page.
     At 1800x400, at the instant `p` reaches 1 under the shipped clamp:
       * the desktop grid is TWO ROWS OF THREE, 921.4px tall, row pitch 470.7px
       * row 1's chips sit at y 259.5 - 287.9  (on screen)
       * row 2's chips sit at y 730.2 - 758.6  - 330px BELOW a 400px viewport
     The clamp protects the grid's TOP EDGE. The chips are not at the top edge.
     Worse, run per card against the stagger: at 1800x400 every one of the SIX
     counters reaches its final value off screen - cards 0-2 finish at grid-top
     255.7 / 204.5 / 153.4, which puts row 1's chips at y 515 / 464 / 413, all
     past a 400px fold. ZERO OF SIX. The clamp was not buying visibility; it
     was buying a 0.94*vh travel cap and nothing else.
     WHAT REPLACES IT IS NOT A NEW RULE, IT IS THE ONE THIS FILE ALREADY HAS.
     Round 72 hit exactly this shape on the phone branch - a fixed window
     measured off the grid's TOP against a grid taller than the window, so the
     ledger "would hit 800 / 800 mg with four cards still below the fold, which
     is a counter that lies" - and tied the END to the grid's BOTTOM edge
     instead: `b = vh * P_TAIL - r.height`. That branch reads 0.62-0.64 at
     every phone height. Where the desktop floor bottoms out, the desktop end
     is handed to the same rule, so there is no second animation system and no
     new constant: `P_TAIL` is round 72's, `H_FLOOR` is round 107's.
     WHY IT IS BOUNDED TO THE CLAMPED REGION, AND WHY THAT BOUND IS NOT TYPED.
     The switch fires exactly where the `Math.max` used to bottom out - i.e.
     `a - H_FLOOR < 0`, i.e. vh < H_FLOOR/P_START = 649 - which is round 115's
     already-derived, already-parsed, already-published clamp crossing. It is
     not a number chosen for this edit; it is the boundary of the region the
     backlog is about. Above it NOTHING MOVES: for vh >= 649 the floored end is
     >= 0, the ternary takes it unchanged, and d649 / d760 / d900 / d953 /
     d1150 / d1400 are byte-identical. Round 71's "desktop must not move" is
     honoured to the digit, and the phone stops cannot see this branch at all.
     THE PRICE, STATED RATHER THAN HIDDEN: the timing is now DISCONTINUOUS at
     vh 649 - travel jumps 610 -> 895.5 as the window shrinks past it, and
     `driveFrac` 0.2775 -> 0.4073. That is a resize-time re-timing, the same
     kind this file already takes at STACK_W = 900 on width, and every value on
     the short side of it is better than every value it replaces. It is not a
     scroll-time jump; nothing moves under the wheel.
     THE `Math.min` IS THE GUARD, NOT DECORATION. It lets the tail rule only
     ever LENGTHEN the window relative to the floored end. If the grid is ever
     short - a dose block removed, a one-row desktop grid - `vh*P_TAIL -
     r.height` rises above `a - H_FLOOR` and the min hands the end straight
     back to the floored value instead of collapsing the travel toward zero.
     It is the desktop mirror of the stacked branch's `if (a - b < vh * 0.4)`
     fallback, written as a bound rather than a second branch.
     WHAT THIS DOES NOT FIX, AND IT IS FILED AS BACKLOG 96 RATHER THAN QUIETLY
     WIDENED INTO: under the FIXED window the last chip row finishes below the
     fold at every desktop height from 649 to ~1150 too (at vh 900 the row
     lands at y 994.8; at vh 953, 1044.6). Fixing that means re-timing
     published stops, which is a different round's decision and needs round
     71's four measured stops re-published. This round fixes the region the
     gate actually fails in and says the rest out loud.
     A FLOOR-SWAP WAS MODELLED FIRST AND REJECTED BY THE GEOMETRY BEFORE IT WAS
     EVER PUSHED. Replacing the `0` with the tail bound as a FLOOR - i.e.
     `Math.max(vh*P_TAIL - r.height, a - H_FLOOR)` - takes `driveFrac` at
     1800x400 to 0.3147, passes the gate, and leaves the end at grid-top -234,
     which puts row 2's chips at y 524.8 in a 400px viewport: STILL OFF SCREEN.
     A green gate on a render that is still wrong is round 117's shipped-and-
     retracted 440 one driver over. It was caught by measuring the chips first
     this time, not by opening the PNG afterwards. Both were done anyway. */
  var H_FLOOR = 610;
  /* Per-card slice inside that progress. Dividing by (n-1) is the round-50
     arithmetic: it lands the LAST chip's START exactly on `end`.
     C_END + C_SPAN MUST equal 1.0 here, and that is not a style choice. The
     round-59 rail runs 0.80 + 0.26 = 1.06, so its last card tops out at 0.95
     and nobody could tell. This ledger prints a TOTAL, and the first push of
     this round shipped 0.78 + 0.30 = 1.08, which made the ledger stop on
     "797 / 800 mg" at full scroll - measured live, not theorised. A proof
     counter that never reaches its own printed total is worse than no counter.
     If a dose or a card is ever added here, keep C_END + C_SPAN = 1.0.

     ---- ROUND 93: C_END IS DERIVED, NOT TYPED (axis 5, backlog 71) ----
     Everything above this line is round 71's and it is all still true. What
     was wrong with it is that it is a COMMENT. The paragraph above documents a
     real, measured, already-shipped break of this exact invariant on this
     exact driver - 0.78 + 0.30 = 1.08 froze the ledger on "797 / 800 mg" at
     full scroll - and the only thing standing between that and the next
     re-tune is a reader noticing the instruction and doing the arithmetic by
     hand. Round 91 hit the identical shape on the round-59 rail and fixed it
     the only way that holds: the last window must END at p = 1, therefore it
     must START at 1 - C_SPAN, so C_END stops being a number anyone can nudge.
     0.70 == 1 - 0.30, so this moves nothing today - proved by re-running the
     probe after and diffing every leaf. It removes the way it breaks tomorrow.
     `tools/scroll_driver_probe.py --target pathway` is now the instrument that
     would catch it if anyone types it back. */
  var C_START = 0.02, C_SPAN = 0.30;
  var C_END = 1 - C_SPAN;   /* INVARIANT: last window must END at p = 1 */

  /* ---- ROUND 128, backlog 104 - THE STACKED PER-CARD WINDOW ----------------
     Everything above this line is round 71/72/93's and still governs DESKTOP,
     which does not move. What follows replaces the STACKED branch's per-card
     timing only.
     THE DEFECT, measured by round 126 and not argued: `pathway` runs at
     0.03455 / 0.03500 / 0.03500 travel-per-scroll at m667 / m844 / m1000 on a
     layout measured as genuinely ONE COLUMN (6 units, 1 left edge, 1 grid
     track). That is 2.9x below the 0.10 no-neighbour floor and 24.1% below the
     0.04552 configuration round 77 explicitly REJECTED - the slowest
     scroll-linked motion ever measured on this build.
     THE MECHANISM IS `C_SPAN` MEETING A STACKED GRID, and it is arithmetic.
     C_SPAN is a FRACTION of the global travel. On desktop the travel is
     ~896px, so 0.30 of it is a 269px window - fine. On a phone the grid is
     2,670px tall and round 72 ties the end to the grid's BOTTOM edge, so the
     travel is ~2,637px and the same 0.30 becomes a 791px window for the SAME
     22px of `--gp` travel. One constant, two orders of geometry.
     ROUND 77 SOLVED THIS EXACT SHAPE ON `shopseq` - a shared one-column window
     split into a per-card window - and that fix was never applied here.
     WHAT REPLACES THE FRACTION IS THE CARD'S OWN EDGE. On the stacked branch a
     card's local progress is `(a - cardTop) / W_CARD`: it starts as the card's
     own top clears the fold and finishes W_CARD of scroll later, per card,
     with no dependence on how tall the grid is or how many cards are in it.
     THAT IS ALSO A STRONGER VERSION OF ROUND 72's CONTRACT, NOT A REPEAL OF
     IT. Round 72 tied the END to the grid's bottom edge so the ledger could not
     "hit 800 / 800 mg with four cards still below the fold, which is a counter
     that lies". Under the fraction that guarantee was GLOBAL and uneven: at
     m844 card 0 finished fully lit with its own top at -50px, i.e. already off
     the top of the viewport (the round-72 comment above concedes the range,
     "between -50px and +382px"). Per card it becomes uniform and local - no
     card's dose can complete before that card itself is on screen, at every
     phone height, which is the thing round 72 actually wanted.
     W_CARD = 264 IS BRACKETED, NOT CHOSEN:
       * UPPER 281.6 = 22 / (0.10 * 0.781212). At or above it the measured span
         reaches 220px and travel-per-scroll falls back to the 0.10 floor - the
         defect is not fixed. (0.781212 is the easeOut 0.01 -> 0.99 crossing
         fraction, `1-0.99**(1/3)` to `1-0.01**(1/3)`, which is what the probe
         measures; it is derived in `captures/round-128-geom.py`, never typed.)
       * LOWER 245.8 = the raw window behind `shopseq`'s FASTEST shipped
         one-column stop (m667, measured span 192px, round 123). The tightest
         per-card window this build has shipped on a phone and had accepted as
         motion rather than a snap.
       * 264 sits at 0.508 of that bracket - 7.4% above the lower bound, 6.2%
         below the upper. Round 107's lesson 1 is why that matters: a constant
         pressed flat against the edge of its own bracket (486 was) is a
         no-op waiting to be discovered.
       * And 264 is within 1.8% of this driver's own shipped DESKTOP window
         (268.80px at d1400, tps 0.10477). The phone gets, to rounding, the
         window desktop already ships and is judged healthy on.
     DO NOT "FIX" A FUTURE REGRESSION HERE BY GATING `travelPerScroll`. Backlog
     104's own instruction: fix the window. The field stays REPORTED, NEVER
     GATED, exactly as round 123's contract says.
     DO NOT RE-DERIVE THE STAGGER FROM `C_SPAN` ON THIS BRANCH. The stagger is
     now the card PITCH itself, because each card reads its own edge - which is
     why `off[]` is cached rather than the stagger being typed. */
  var W_CARD = 264;

  function easeOut(t) { var u = 1 - t; return 1 - u * u * u; }
  function pad3(v) { return ('00' + v).slice(-3); }

  var live = false, ticking = false, lastP = -1;

  /* ROUND 128 - each card's top OFFSET inside the grid, cached.
     The per-card window needs every card's own top edge every frame, and
     reading six rects per rAF would add five forced layouts to a phone scroll.
     The offsets only change on reflow, so they are measured once per
     enable()/resize and added to the ONE grid rect `paint` already reads.
     Per-frame layout cost is therefore unchanged from round 72. */
  var off = [], offH = -1;
  /* ROUND 142, backlog 121 - the label group's own edges, cached on the SAME
     reflow as `off[]` and by the same rule: six more rects per frame would be
     six more forced layouts on a phone scroll. `labT/labB` are the top and
     bottom of each card's `.ing-dose` + `h3` union - the thing that says WHAT
     the photograph under it is, i.e. this grid's answer to a `thead`. */
  var labT = [], labB = [];
  /* ROUND 194, backlog 205 — WHICH CARDS ARE ACTUALLY RENDERED.
     The phone disclosure (`.ing-grid.is-collapsed`) takes cards 3-6 to
     `display:none`. A `display:none` element's `getBoundingClientRect()` is all
     zeros, so its cached `off[i]` becomes `-gr.top` — a number that is not a
     position at all — and the stacked branch below would read it as "this card
     is far above the anchor", clamp `local` to 1, and print that card's full
     dose into `counted`. The collapsed ledger would jump straight to 800/800
     for four cards nobody can see: the section would be counting its own label
     off screen. So the population is recomputed on the SAME reflow as `off`,
     and a non-rendered card is excluded from the drive, from the dock-collision
     search, and from the count. `offsetParent === null` is the cheap, exact
     test for "not rendered" on this build — nothing in `#pathway` is
     `position:fixed`, which is the one case that test gets wrong.
     It costs one property read per card per RE-MEASURE, not per frame, and the
     re-measure is already gated behind the height witness in `paint`. Expanding
     the grid changes its height, so the witness fires and the four cards rejoin
     the count with correct offsets on their own. */
  /* ROUND 194, backlog 205, SECOND EDIT OF THE SAME ROUND — the shadow.
     NAMED `cardVis` AND NOT `vis`, AND THAT IS NOT A STYLE CHOICE. Round 194
     shipped this as `vis` first and measured it live: `paint()` already declares
     its OWN `var vis = 1` for the round-142 ledger-dock alpha, and a `var` is
     function-scoped, so inside `paint` the name resolved to that NUMBER. The
     guard read `vis.length === n` as `undefined === 6`, never fired, and all
     four hidden cards went on counting. It failed CLOSED — round 71's exact
     behaviour, no crash, no visible break — which is precisely why it would
     have shipped unnoticed if the round's own W1 falsifier had not asked for
     the collapsed ledger figure by number. The symptom that identified it in one
     read: a hidden card's `off[i]` is `0 - gr.top`, so `local` becomes
     `a / W_CARD` (> 1 at any scroll where the grid is on screen) and the chip
     clamps to its FULL dose while the VISIBLE card above it still reads 000 —
     a pattern no legitimate scroll position can produce.
     GENERAL RULE, and the file now has three `var vis` in three different
     closures: before adding a driver-level variable, grep the enclosing IIFE for
     the name. A `var` collision between a closure variable and a function-local
     is invisible to `node --check` and to every screenshot. */
  var cardVis = [];
  var ledger = band.querySelector('[data-path-ledger]');
  var lastVis = null, ledPad = 0;
  function measure(r) {
    var gr = r || grid.getBoundingClientRect();
    cardVis = cards.map(function (c) { return c.offsetParent !== null; });
    off = cards.map(function (c) {
      return c.getBoundingClientRect().top - gr.top;
    });
    labT = []; labB = [];
    cards.forEach(function (c, i) {
      var d = c.querySelector('.ing-dose'), h = c.querySelector('h3');
      /* A hidden card's label rects are zeros too, and zeros would win the
         `bestD` search below against every real card. Null it out at source so
         the dock-collision loop's existing `labT[li] == null` guard covers the
         hidden case for free, rather than adding a second guard beside it. */
      if (!cardVis[i] || !d || !h) { labT.push(null); labB.push(null); return; }
      var cr = c.getBoundingClientRect();
      var dr = d.getBoundingClientRect(), hr = h.getBoundingClientRect();
      /* RELATIVE TO THE CARD, NOT TO THE GRID, and that is the whole point.
         `.pathseq--live .ing-grid > .ing` carries
         `translateY((1 - --gp) * 22px)`, so a card's distance from the GRID's
         top changes by up to 22px as the driver runs and a grid-relative cache
         is stale by that much every frame. The label moves WITH its card, so
         the card-relative offset is transform-invariant and cacheable.
         Round 142 shipped the grid-relative version first and measured it: it
         left up to 19.6px of residual occlusion, right inside the 22px band. */
      labT.push(Math.min(dr.top, hr.top) - cr.top);
      labB.push(Math.max(dr.bottom, hr.bottom) - cr.top);
    });
    /* ROUND 142 - the lead, cached on the same reflow. `getComputedStyle` in a
       scroll handler is a forced style recalc every frame; it belongs here,
       where a reflow has already happened, not in `paint`. */
    if (ledger) {
      ledPad = parseFloat(getComputedStyle(ledger).paddingTop) || 0;
    }
    offH = gr.height;
  }

  /* Round 72: the width gate is gone. The only bail left is reduced motion -
     a stacked one-column grid is a real layout for this section, not a broken
     one, so there is nothing here to bail OUT of. */
  function isLive() { return !isReduced(); }

  function paint() {
    ticking = false;
    if (!live) return;

    var r = grid.getBoundingClientRect();
    /* ROUND 128 - the offsets are cached off a reflow, and a late image load is
       a reflow the resize listener never hears. The grid's own height is the
       cheap witness: one float compare per frame, and a re-measure ONLY when
       the geometry actually moved. Not a timer, not a ResizeObserver. */
    if (Math.abs(r.height - offH) > 1) measure(r);
    var vh = window.innerHeight || 1;
    var a = vh * P_START, b;
    if (window.innerWidth <= STACK_W) {
      /* stacked: land the count on the grid's BOTTOM edge, not a fixed offset */
      b = vh * P_TAIL - r.height;
      /* If the stacked grid is ever short (a dose block removed, a very tall
         phone), the tail rule collapses or inverts the travel. Fall back to
         the fixed window rather than divide by something near zero. */
      if (a - b < vh * 0.4) b = vh * P_END;
    } else {
      b = vh * P_END;
      /* ROUND 104 - floor the travel. See H_FLOOR above.
         ROUND 118, backlog 94 - and where that floor bottoms out, the end goes
         to round 72's tail rule, not to a literal 0. The `0` capped travel at
         0.94*vh and bought no visibility: measured at 1800x400 it finished all
         six counters off screen. Bounded to vh < H_FLOOR/P_START = 649, so no
         published desktop stop moves. Full derivation above H_FLOOR. */
      if (a - b < H_FLOOR) b = a - H_FLOOR;
      /* ROUND 121, backlog 96 - THE SAME `Math.min` ROUND 118 WROTE, APPLIED TO
         THE WHOLE DESKTOP BRANCH INSTEAD OF ONLY THE bFloor < 0 CASE.
         Round 118 fixed the region the GATE fails in and filed the rest as 96:
         "under the FIXED window the last chip row finishes below the fold at
         every desktop height from 649 to ~1150 too". Measured on the shipped
         build before this edit, at the instant `p` reaches 1:
           * vh 900 - grid top 235.8, last chip row bottom 994.6 -> 3 of 6
           * vh 953 - grid top 285.9, last chip row bottom 1044.8 -> 3 of 6
         `driveFrac` reads 0.2449 / 0.2425 there and the gate is CLEAN, so no
         field sees this. It was found by measuring chip rects, as 118 was.
         NO NEW CONSTANT AND NO NEW RULE. The end is the LATER of the fixed /
         floored end and round 72's tail rule, which is precisely what the
         ternary above already did below vh 649. The bound is not typed: the
         min binds exactly when the fixed end would leave the grid's bottom
         below P_TAIL*vh - i.e. when the count would finish off screen - and
         hands back the fixed end otherwise. That is the derivation.
         PROOF THAT IT IS SELF-DERIVING RATHER THAN A NUDGE: d1400 DOES NOT
         MOVE. There tail = 450.6 > b_fixed = 420, the min declines, and the
         stop stays 0.2949 byte-identical - because its chip row already clears
         (420 + 758.8 = 1178.8 < 1400). A fix that moved every stop would be a
         re-tune; one that moves exactly the stops whose artifact is broken is
         a rule. All three phone stops are on the stacked branch and cannot see
         this code at all.
         THE PRICE, AND IT IS ROUND 71's CONTRACT: five desktop stops re-time
         (d649, d760, d900, d953, d1150), all UP, all still above the 0.20
         gate. Round 71's "desktop must not move" is deliberately broken here -
         that is why 118 filed this as a separate round's decision rather than
         widening into it - and round 121's QUALITY.md re-publishes the whole
         series with the reason, as backlog 82 requires.
         A PRICE ROUND 118 PUBLISHED IS REPAID: 118's timing DISCONTINUITY at
         vh 649 (travel 610 -> 895.5 across the crossing) closes, because both
         sides of it now run the same rule. d648 and d649 land together.
         THE `Math.min` IS STILL THE GUARD, NOT DECORATION, and its round-118
         header still holds verbatim: if the grid is ever short - a dose block
         removed, a one-row desktop grid - the tail rises above the floored end
         and the min hands the end straight back rather than collapsing travel
         toward zero. Do not turn it into a `Math.max`, and do not bound it
         with a typed viewport threshold: the geometry is the bound. */
      b = Math.min(b, vh * P_TAIL - r.height);
    }
    var p = (a - r.top) / (a - b);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);

    /* ============================================================
       ROUND 142 - CONVERSION ARCHITECTURE (axis 3), backlog 121.
       THE COUNTER STEPS ASIDE FOR THE INGREDIENT IT IS COUNTING.

       Measured before it was written, at 10px per step over the whole grid at
       m360/m390/m414 (`captures/round-142-path-before.json`): round 72's
       ledger, docked at `top:83px`, covers **41.6px = 65.74% of every card's
       label group**, on all six cards, at all three phone widths, for ~105px
       of scroll each. Identical to two decimals at every width, so it is a
       CONSTANT, not a slope.
       WHAT MADE IT A DEFECT RATHER THAN ORDINARY STICKY BEHAVIOUR, and it is
       the one field that decided it: at the worst-occlusion stop the card's
       own body copy is **100% on screen** (`bodyVis@w = 1.000`, 6 of 6 cards,
       3 of 3 widths). The reader is reading a paragraph whose ingredient name
       is two-thirds hidden. Occlusion at the top of the screen is harmless
       only when the thing named has already left; here it has not.
       WHY A FADE AND NOT A MOVE: round 141 proved geometrically that a sticky
       element cannot continuously dodge a taller neighbour - every dodge either
       snaps or hides for hundreds of px. Do not re-derive that.
       WHY IT FADES BEFORE CONTACT, NOT ON CONTACT: a fade that starts when the
       boxes touch still paints a partly-visible ledger over the name for the
       whole ramp, which is round 141's lesson 6 - a partial fix that reads like
       a fix. The ramp is therefore run on the GAP, so alpha is already 0 by the
       time the rects meet and the occlusion measures 0.0px on the unchanged
       instrument rather than on a moved ruler.
       THE FADE WINDOW IS NOT TYPED: it is the ledger's OWN docked height, read
       live. The counter starts stepping aside exactly one ledger-height before
       contact, so the window scales with the type it contains.
       WHY THIS IS NOT A LOSS: `.path-ledger` is `aria-hidden="true"` and its
       job is to represent doses the reader CANNOT see yet. When the ingredient
       itself is directly under it, the counter of the proof is redundant and
       the proof is not.
       IT DRIVES `filter:opacity()`, NEVER `opacity` OR `transform`: `.rv` owns
       both of those at (0,2,0) later in the sheet and transitions them .78s.
       `filter` composes, carries no transition, and is scroll-linked, so this
       reads as a breath around each card, never a blink.
       IT IS SET BEFORE THE `lastP` REPAINT GUARD ON PURPOSE. That guard is a
       ~5.8px-of-scroll quantiser on this section's travel; running the fade
       behind it would band a 41px ramp into seven steps.
       ============================================================ */
    if (ledger && window.innerWidth <= STACK_W) {
      var lr = ledger.getBoundingClientRect();
      var fade = lr.height || 40;
      var lead = ledPad;
      /* TWO READS PER FRAME, NOT SEVEN. The cards are ~445px apart on a phone
         and the whole collision window is ~105px, so at most ONE card can be
         near the dock line at a time. Pick that card off the cached offsets
         (accurate to the 22px transform, which is far inside a 445px pitch),
         then read that ONE card's live rect for the exact number. */
      var best = -1, bestD = Infinity;
      for (var li = 0; li < labT.length; li++) {
        if (labT[li] == null) continue;
        var d0 = Math.abs((r.top + off[li] + labT[li]) - lr.top);
        if (d0 < bestD) { bestD = d0; best = li; }
      }
      var vis = 1;
      if (best >= 0) {
        var cr = cards[best].getBoundingClientRect();
        var lt = cr.top + labT[best], lb = cr.top + labB[best];
        var gap = lt > lr.bottom ? lt - lr.bottom
                : (lb < lr.top ? lr.top - lb : 0);
        /* THE LEAD, AND IT IS NOT A FUDGE FACTOR. A scroll-linked value is
           always one frame behind the scroll that caused it. Round 142's first
           correct build measured that exactly: at m360/scrollY 11856 the
           ledger still carried alpha 0.088 - the value that was RIGHT at
           11846 - and painted 6.34px over card 0's name. The driver was
           correct; the pipeline was one frame stale.
           So alpha reaches 0 one LEAD before contact, and the lead is the
           ledger's OWN vertical padding, read off the box rather than typed.
           It is the air the box already carries, so a user cannot see the fade
           finish early, and it absorbs a stale frame at any scroll speed a
           phone can produce over a 10px sample. */
        vis = (gap - lead) / fade;
        if (vis > 1) vis = 1;
        if (vis < 0) vis = 0;
      }
      var vs = vis.toFixed(3);
      if (vs !== lastVis) { ledger.style.setProperty('--plv', vs); lastVis = vs; }
    } else if (lastVis !== null) {
      ledger.style.removeProperty('--plv');
      lastVis = null;
    }

    /* 0.002 of the total is under 2mg on an 800mg label - below the smallest
       change any chip can render. Same repaint guard as the rail. */
    if (Math.abs(p - lastP) < 0.002) return;
    lastP = p;

    var n = cards.length;
    var step = n > 1 ? (C_END - C_START) / (n - 1) : 0;
    /* ROUND 128, backlog 104 - the stacked branch drives each card off its OWN
       top edge across W_CARD, not off a fraction of a 2,637px global travel.
       Full derivation at W_CARD above. `off.length === n` is the guard: if the
       cache was never taken the branch declines and round 71's fraction runs,
       so the failure mode is "round 127", never a dead ladder. */
    var perCard = (window.innerWidth <= STACK_W) && off.length === n;
    var counted = 0;
    for (var i = 0; i < n; i++) {
      /* ROUND 194, backlog 205 — a card the disclosure has hidden is not driven
         and is not counted. Its chip is left holding whatever the last visible
         state wrote, which is what `disable()` would restore anyway, and it is
         `display:none` so nothing about it is observable until the height
         witness re-measures it back into the population. */
      if (cardVis.length === n && !cardVis[i]) continue;
      var local = perCard
        ? (a - (r.top + off[i])) / W_CARD
        : (p - (C_START + step * i)) / C_SPAN;
      local = local < 0 ? 0 : (local > 1 ? 1 : local);
      var e = easeOut(local);
      cards[i].style.setProperty('--gp', e.toFixed(4));
      var v = doseDec[i] ? Math.round(doses[i] * e * 10) / 10 : Math.round(doses[i] * e);
      counted += v;
      if (chips[i]) {
        /* "2.5" is already three glyphs wide, so the odometer keeps its fixed
           width without zero padding a decimal into nonsense like "002". */
        var txt = (doseDec[i] ? v.toFixed(1) : pad3(v)) + rest[i];
        /* Only touch the DOM when the rendered string actually changed. */
        if (chips[i].textContent !== txt) chips[i].textContent = txt;
      }
    }
    if (totalEl) {
      var t = totalDec ? (Math.round(counted * 10) / 10).toFixed(1) : pad3(Math.round(counted));
      if (totalEl.textContent !== t) totalEl.textContent = t;
    }
    if (fill) {
      fill.style.setProperty('--tp', (totalMg ? counted / totalMg : p).toFixed(4));
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  function enable() {
    if (live) return;
    live = true;
    lastP = -1;
    band.classList.add('pathseq--live');
    measure();                                  /* ROUND 128 - see `off` above */
    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  }

  function disable() {
    if (!live) return;
    live = false;
    band.classList.remove('pathseq--live');
    window.removeEventListener('scroll', onScroll);
    /* Round 55's lesson: hand every driven surface back whole. Clear the custom
       properties AND put the real printed numbers back, so a frozen mid-count
       value can never outlive the driver. */
    cards.forEach(function (c) { c.style.removeProperty('--gp'); c.classList.add('in'); });
    /* ROUND 142 - hand the ledger back whole too. A frozen mid-fade alpha must
       never outlive the driver: round 55's rule, applied to `--plv`. */
    if (ledger) { ledger.style.removeProperty('--plv'); }
    lastVis = null;
    chips.forEach(function (ch, i) { if (ch) ch.textContent = origin[i]; });
    if (totalEl) totalEl.textContent = originTotal;
    if (fill) fill.style.removeProperty('--tp');
    grid.classList.add('in');
  }

  if (isLive()) enable();

  /* ROUND 180 — one handler, two events. */
  function reassess() {
    /* ROUND 128 - `enable()` returns early when already live, so the offset
       cache has to be invalidated here explicitly. `paint` re-measures on the
       next frame via the height witness. */
    offH = -1;
    if (isLive()) { enable(); lastP = -1; onScroll(); }
    else disable();
  }

  window.addEventListener('resize', reassess, { passive: true });
  if (rmq) {
    if (rmq.addEventListener) rmq.addEventListener('change', reassess);
    else if (rmq.addListener) rmq.addListener(reassess);
  }
})();

/* ============================================================
   ROUND 76 — MOTION & FEEL (axis 5), backlog 42.
   FOURTH scroll-driven moment: the #testing comparison ledger.

   The problem, measured before it was written: 5,654px of the 15,045px desktop
   home page was one-shot `.rv` reveal only — it faded up once on entry and then
   sat completely inert for the rest of the scroll. The comparison table is the
   largest single inert block in that stretch and the one with a natural unit to
   drive: it is a list of seven verifiable claims, so it can PRINT itself, one
   line at a time, instead of appearing all at once like a graphic.

   What it does: each row's "NarrowPath" cell washes in from the left across its
   own slice of the section's scroll travel, a 3px azure rule draws down the
   row's left edge with it, and a ledger above the table counts the lines that
   have finished printing. It is scroll-LINKED, not scroll-triggered — `--rw` per
   row and `--cp` on the bar are recomputed from the table's live rect every
   frame, so the count runs back DOWN on the way up.

   Why `testing` and not `promise` or `buybox`: `buybox` is the buy surface and
   motion there is a conversion risk (round 71's judgement, not relitigated).
   `promise` is a guarantee panel with no repeating unit — driving it would mean
   inventing one. `testing` already had seven rows asking to be counted.

   It is its OWN system: its own selectors (`[data-proofseq]`, `[data-proof-*]`),
   its own custom properties (`--rw`, `--cp`), its own live class
   (`proofseq--live`). It is not a fourth caller into `seq_pin`, the round-59
   rail, or the round-71 pathway ledger, and it touches none of their contracts.

   Width gate: NONE, deliberately, and the reason is geometric not ideological.
   Round 71 gated its driver off at <=900px and left the phone with no driven
   motion at all; round 72 had to undo that. The thing that actually breaks a
   driver on a phone is TIMING, so the timing here is tied to the table's own
   BOTTOM edge at every width (see `paint`) rather than to a fixed offset. The
   table does not reflow — it keeps `min-width:560px` inside `overflow-x:auto` —
   so the geometry the driver reads is the same shape at 390px and at 1800px.

   Bail-outs, in order: no section -> no table -> no rows -> reduced motion. In
   every bail-out `proofseq--live` is never added, so the CSS falls back to the
   `.rv` reveal that ran here for 75 rounds, with every cell at its full tint and
   the counter on its real printed total. Failure mode is "round 75", never a
   half-washed row and never a counter stuck on 0.
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-proofseq]');
  if (!band) return;
  var table = band.querySelector('[data-proof-table]');
  if (!table) return;
  var rows = Array.prototype.slice.call(band.querySelectorAll('[data-proof-row]'));
  if (!rows.length) return;

  var countEl = band.querySelector('[data-proof-count]');
  var fill = band.querySelector('[data-proof-fill]');
  /* The denominator comes out of the DOM, which got it out of Liquid, which
     counted the real rows. Nothing here is typed. */
  var total = parseInt(table.getAttribute('data-proof-total'), 10) || rows.length;
  var originCount = countEl ? countEl.textContent : '';

  /* ROUND 180, backlog 174 — held query, read at USE time. See the shop grid
     below for the full note; same defect, same fix, same DRIVER classification. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  /* The window, measured against the TABLE's own rect at every width:
     printing starts as the table's top edge clears P_START * vh, and finishes
     when its BOTTOM edge reaches P_TAIL * vh — i.e. the last line prints with
     the whole table on screen, never with rows still below the fold. That is
     round 72's stacked-ledger rule, applied here at all widths because the
     table's height is what varies (rows are editable), not its layout.
     P_FLOOR is the collapse guard: if a future edit leaves few enough rows that
     the tail rule gives less than a third of a viewport of travel, fall back to
     a fixed window instead of dividing by something near zero. */
  var P_START = 0.92, P_TAIL = 0.58, P_FLOOR = 0.34;
  /* Per-row slice. Same arithmetic as the round-71 ledger and the same hard
     constraint: R_END + R_SPAN MUST equal 1.0, so the LAST row finishes exactly
     at p = 1. This ledger prints "N of N lines"; a counter that stops on 6 of 7
     at full scroll is worse than no counter. Dividing by (n-1) lands the last
     row's START on R_END. */
  var R_START = 0.02, R_END = 0.70, R_SPAN = 0.30;

  function easeOut(t) { var u = 1 - t; return 1 - u * u * u; }

  var live = false, ticking = false, lastP = -1;

  function isLive() { return !isReduced(); }

  function paint() {
    ticking = false;
    if (!live) return;

    var r = table.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    var a = vh * P_START;
    var b = vh * P_TAIL - r.height;
    if (a - b < vh * P_FLOOR) b = a - vh * P_FLOOR;
    var p = (a - r.top) / (a - b);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    /* A row is ~560px of wash; 0.002 of the travel moves it under a pixel. */
    if (Math.abs(p - lastP) < 0.002) return;
    lastP = p;

    var n = rows.length;
    var step = n > 1 ? (R_END - R_START) / (n - 1) : 0;
    var done = 0, sum = 0;
    for (var i = 0; i < n; i++) {
      var local = (p - (R_START + step * i)) / R_SPAN;
      local = local < 0 ? 0 : (local > 1 ? 1 : local);
      var e = easeOut(local);
      sum += e;
      /* 0.95, NOT `local >= 1`. Caught by eye in this round's own proof-25
         shot, which the probe passed: the first row was washed to 0.988 and
         the second to 0.774, the bar sat at 26%, and the counter still read
         "0 of 7". A counter that disagrees with the rows the visitor is
         looking at reads as broken, not as precise. The last 5% of the
         ease-out is under two pixels of wash across a 560px cell — invisible,
         so it must not be the difference between counted and not. The end
         still lands on exactly 7: at p = 1 every row is at 1.0. */
      if (e >= 0.95) done++;
      rows[i].style.setProperty('--rw', e.toFixed(4));
    }
    if (countEl) {
      var txt = String(done);
      if (countEl.textContent !== txt) countEl.textContent = txt;
    }
    /* The bar reads the MEAN row progress, not `done / total`. `done` is an
       integer and would step the bar in seven jumps; the mean is smooth and
       still lands on exactly 1.0 when the last row completes, because
       R_END + R_SPAN = 1.0 above. */
    if (fill) fill.style.setProperty('--cp', (n ? sum / n : 1).toFixed(4));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  function enable() {
    if (live) return;
    live = true;
    lastP = -1;
    band.classList.add('proofseq--live');
    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  }

  function disable() {
    if (!live) return;
    live = false;
    band.classList.remove('proofseq--live');
    window.removeEventListener('scroll', onScroll);
    /* Round 55's rule: hand a driven surface back WHOLE. Clear the properties
       and restore the printed total, so a frozen mid-count value can never
       outlive the driver. */
    rows.forEach(function (row) { row.style.removeProperty('--rw'); });
    if (countEl) countEl.textContent = originCount;
    if (fill) fill.style.removeProperty('--cp');
    table.classList.add('in');
  }

  if (isLive()) enable();

  /* ROUND 180 — one handler, two events. */
  function reassess() {
    if (isLive()) { enable(); lastP = -1; onScroll(); }
    else disable();
  }

  window.addEventListener('resize', reassess, { passive: true });
  if (rmq) {
    if (rmq.addEventListener) rmq.addEventListener('change', reassess);
    else if (rmq.addListener) rmq.addListener(reassess);
  }
})();

/* ============================================================
   ROUND 77 - axis 5, backlog 42. THE SHOP GRID DEAL.
   The fifth scroll-driven system on this build, and the second
   section taken out of the 4,633px one-shot-only stretch of the
   desktop home page (round 76 took `testing`, 1,021px; this takes
   `shop`, 976px).

   WHY `shop` AND NOT `easy` OR `promise`: it is the only remaining
   section with a repeating unit already in the markup - four cards,
   each with an image, a name, a price and a CTA. `easy` and `promise`
   are prose panels; driving either means inventing a unit first,
   which is a design round and should be scheduled as one rather than
   smuggled in here. `buybox` stays still - buy surface, round 71's
   judgement, not relitigated.

   IT IS ITS OWN SYSTEM. Own selectors (`[data-shopseq]`,
   `[data-shop-grid]`, `[data-shop-card]`), own custom property
   (`--cd`), own live class (`shopseq--live`). It never reads or
   writes `--ap`, `--rp` / `--pp` / `--np`, `--gp` / `--tp`, `--rw` /
   `--cp`, `[data-seq]`, the header, or anything in the hero.

   NOT A FOURTH COUNTER, deliberately. See the CSS block and round
   76's lesson 6.

   WIDTH GATE: NONE, and the reason is geometric, not ideological -
   the round-77 brief requires this decision be stated in the file.
   The grid RE-LAYS OUT by width (4 columns > 2 at 1000px > 1 at
   520px), so its HEIGHT is what changes, from ~500px to ~2,500px.
   That is exactly what the window below is keyed to: it opens as the
   grid's top edge clears P_START * vh and closes when its BOTTOM edge
   reaches P_TAIL * vh, so a taller grid automatically buys itself
   proportionally more travel and each card still lands while it is on
   screen. A fixed-offset window is what breaks a driver on a phone,
   not the phone. Round 71 gated its driver off at <=900px and round
   72 had to undo it; this one does not repeat that.

   Bail-outs, in order: no section -> no grid -> no cards -> reduced
   motion. In every bail-out `shopseq--live` is never added, so the CSS
   falls back to the plain `.rv` reveal that ran here for 76 rounds,
   with every card at its full shadow and its normal spring hover.
   The failure mode is "round 76", never a card stuck 34px low.
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-shopseq]');
  if (!band) return;
  var grid = band.querySelector('[data-shop-grid]');
  if (!grid) return;
  var cards = Array.prototype.slice.call(band.querySelectorAll('[data-shop-card]'));
  if (!cards.length) return;

  /* ROUND 180, backlog 174 — HOLD THE QUERY, READ IT AT USE TIME.
     Was a one-shot `.matches` read at parse time, so a session that opened with
     Reduce Motion ON never built anything and stayed dead forever after the
     visitor turned it off (measured: `live=false`, `inlineDistinct=1` before AND
     after the flip, captures/round-180-rm-BEFORE.json ARM B). Round 178 fixed
     this shape in the hero; this is the same fix in the shop grid. Safe to arm
     late because this is a scroll-linked DRIVER, not an entrance ladder, and it
     already owns a symmetric `disable()` written for the resize path. */
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isReduced() { return rmq ? rmq.matches : false; }

  /* Same window shape and the same three numbers as the round-76 proof
     ledger, for the same reason: the driven element's own rect is the
     only thing that stays honest across a reflow. P_FLOOR is the
     collapse guard - if a future edit leaves a grid short enough that
     the tail rule gives less than a third of a viewport of travel,
     fall back to a fixed window rather than divide by ~0. */
  var P_START = 0.92, P_TAIL = 0.58, P_FLOOR = 0.34;
  /* Per-card slice. HARD CONSTRAINT, third system to carry it:
     C_END + C_SPAN MUST equal 1.0, so the LAST card finishes exactly
     at p = 1. If these stop summing to 1.0 the fourth card is still
     mid-lift when the grid has fully passed, and the section ships a
     card that never lands. Same rule as `R_END + R_SPAN` (round 76)
     and the pathway ledger's `C_END + C_SPAN` (round 71). */
  var C_START = 0.02, C_END = 0.70, C_SPAN = 0.30;
  /* The hand-back threshold. NOT 1.0, and not round 76's 0.95 either -
     this one is derived from the travel it governs. The lift is 34px,
     so at e = 0.98 the card has under 0.7px left to move: the swap
     from driven to sprung is under a pixel and cannot be seen. Wait
     for a literal 1.0 and a card on a phone hands itself back only
     after the grid has fully passed, which is often after that card
     has already left the screen - it would never be hoverable. */
  var SETTLE = 0.98;

  function easeOut(t) { var u = 1 - t; return 1 - u * u * u; }

  var live = false, ticking = false, lastP = -1;
  var settled = cards.map(function () { return false; });

  function isLive() { return !isReduced(); }

  /* THE ONE-COLUMN BRANCH, and the reason it exists is a defect the probe
     passed and the SCREENSHOT caught (round 76's lesson 1, paying out again in
     the round that inherited it).

     The shared-window arithmetic below is correct at every width and readable
     at only two of them. At 4 columns and at 2 columns the cards sit beside
     each other, so a card that is 34px low is 34px low NEXT TO one that has
     landed — the neighbour is what makes the motion legible. At 520px the grid
     collapses to ONE column, the grid becomes 2,377px tall, and the phone probe
     says `onScreen: 1`. There is no neighbour. Worse, each card's slice then
     stretches across ~800px of scroll for 34px of lift — 4% of scroll speed,
     which is not slow motion, it is no motion. The driver was live, correct and
     invisible.

     So at one column each card is driven by ITS OWN rect instead of by the
     grid's: it lifts as it enters, over 0.42 of a viewport (~355px), which is
     ~10% of scroll speed and actually reads. This is a width-keyed BRANCH, not
     a bail-out — the round-72 precedent for exactly this problem. Round 71
     switched its driver OFF below 900px and round 72 had to undo it; the phone
     gets different timing, never no motion.

     520 is not an invented number. It is the `.cards` grid's own
     `grid-template-columns:1fr` breakpoint in np.css. If that breakpoint moves,
     this moves with it. */
  var ONE_COL = 520;
  var S_IN = 0.94, S_OUT = 0.52;

  /* ROUND 101, backlog 78. THE ONE-COLUMN WINDOW NEEDED A PIXEL FLOOR, and
     the number is arithmetic, not taste.

     The defect: the per-card window above is `vh * (S_IN - S_OUT)` = 0.42vh,
     a HEIGHT function, but the thing it has to cover — the band's own scroll
     — is a fixed PIXEL height (~4,380px at one column, measured, see below).
     So the fraction of the band that is in motion falls with the viewport,
     linearly, and there is no width at which anyone looked. Round 97 recorded
     `driveFrac` 0.2235 at m667 against a 0.20 floor and called it the thinnest
     margin on the build. It is not a margin. Swept below 667 for the first
     time this round, on the live theme:

         vh 667 -> 0.2235   PASS      vh 600 -> 0.1966   FAIL
         vh 555 -> 0.1849   FAIL      vh 520 -> 0.1769   FAIL
         vh 480 -> 0.1642   FAIL

     555 is not a hypothetical: it is an iPhone SE's VISUAL viewport in Safari
     once the browser chrome is showing (667 device px minus ~112 of chrome).
     The shortest real phone this site has was already below the floor, and
     every stop anyone had ever run was at or above it.

     The model, fitted to the measured stops and good to ~1%:

         driveFrac  =  n * W / (B + vh),   n = 4 cards,  B ~ 4,380px

     which gives the two constraints the floor sits between:

       (a) driveFrac >= 0.20 at the shortest swept stop (vh 480):
           W >= 0.20 * (4380 + 480) / 4  =  243.0px
       (b) legibility. Round 77 measured the shared-window version at 4% of
           scroll speed and called it "not slow motion, no motion", and set
           this branch at ~10%. 34px of travel over W:
           34 / W >= 0.10  ->  W <= 340.0px

     W_FLOOR = 300 sits inside [243, 340] with double-digit margin on BOTH
     sides — 23.4% clear of the drive floor, 13.3% clear of the legibility
     ceiling — instead of shipping flush against either. Round 99's rule: a
     number chosen at the edge of its band is inside the noise.

     ---- ROUND 123, backlog 92: CONSTRAINT (b) ABOVE IS WRONG, AND IT IS THE
          COMMENT THAT WAS WRONG, NOT THE CONSTANT. `W_FLOOR = 300` STANDS. ----

     `34 / W` is NOT the speed anyone sees. `W` is the NOMINAL window; the
     scroll distance the card actually travels over is shorter, for two
     reasons that compound:

       1. `easeOut` is cubic, so the last ~22% of the window carries under 1%
          of the 34px and moves sub-pixel. It is window, not motion.
       2. THE DRIVEN TRANSFORM FEEDS BACK INTO THE DRIVING RECT. `lj` is read
          off `cards[j].getBoundingClientRect()`, and that rect INCLUDES the
          card's own translateY. As the card rises, its top closes on the
          anchor 34px FASTER than the page scrolls, so the loop shortens the
          real span by almost exactly one travel.

     Measured on the live theme at five one-column heights (round 123, series
     dumped from `scroll_driver_probe.py --dump-series`, fitted r2 0.9911):

         span  =  0.760 * W  -  38.2      (px of scroll for 98% of the lift)

     against the analytic prediction 0.781*W - 26.6. So the real speeds are:

         stop     nominal 34/W     MEASURED 34*0.98/span
         m480       0.11333              0.18109
         m714       0.11333              0.17354
         m760       0.10652              0.16019
         m844       0.09592              0.14362
         m1000      0.08095              0.11900

     Backlog 92 filed the three nominal figures as sub-0.10 violations. They
     are not violations; they are the wrong quantity. The slowest stop this
     branch ships is m1000 at 0.11900.

     THE HONEST BRACKET IS MEASURED AGAINST A CASE THAT WAS ACCEPTED AND A CASE
     THAT WAS REJECTED, not against a ratio:

       * REJECTED, measured: round 77's own defect, reproduced by forcing
         `.cards` to one column at w560 so the SHARED window drives a
         one-column grid — 732px of scroll for the lift, **0.04552**. Note it
         scores `driveFrac` **0.6806**, the best number on the whole build.
         The gate that watched this branch for 22 rounds rates the rejected
         configuration as its healthiest. `driveFrac` cannot see this defect
         and never could.
       * ACCEPTED, measured: w768h1024, the slowest stop the build actually
         ships — **0.09686**, BELOW the 0.10 that (b) asserts is a floor, and
         never once filed in 122 rounds. It is fine because at 768px the grid
         is TWO columns and a card that is 34px low is 34px low NEXT TO one
         that has landed. 0.10 was never a build-wide rule; it is a
         NO-NEIGHBOUR rule, which is what the prose at the top of this block
         already says.

     Inverting the fitted span model at the accepted floor gives the real
     ceiling on this constant:

         W <= 502.9px      (0.09686, the slowest accepted speed)
         W  = 1013.4px     would reproduce round 77's rejected 0.04552

     W_FLOOR = 300 is bracketed by [273.5-278.5 (round 113, measured), 502.9
     (round 123, measured)] — 7.72% clear low, 67.65% clear high. And the
     `max()` is SOUND: the largest window this branch can ever produce is
     420px at m1000, which is still 16.5% under the 502.9 ceiling. There is no
     legibility defect above the crossing and there is nothing here to fix.

     DO NOT "FIX" THIS BY PINNING `wWin = W_FLOOR` AND DROPPING THE vh TERM.
     Round 123 pre-registered exactly that edit and then measured its way out
     of it: it would have cut `driveFrac` at m1000 from 0.2934 to ~0.2096 to
     repair a defect that does not exist.

     ANCHORED AT ENTRY, NOT AT EXIT, and that is the whole difference between
     a fix and gaming the gate. Widening the window by moving the START earlier
     would put the extra travel BELOW the fold, where `driveFrac` still counts
     it and no human can see it. So the start stays pinned at `vh * S_IN` (top
     edge entering from the bottom) and the window is extended DOWNWARD: at
     vh 480 the card finishes arriving with its top at 0.31vh, still well on
     screen. Every pixel of the added drive is visible.

     Above vh 714 (= 300 / 0.42) the vh term wins and this branch is
     byte-identical to round 77's — m844 and m1000 do not move. */
  var W_FLOOR = 300;

  function paint() {
    ticking = false;
    if (!live) return;

    var vh = window.innerHeight || 1;
    var n = cards.length;

    if (window.innerWidth <= ONE_COL) {
      /* Per-card window. `lastP` is not meaningful here (there is no single p),
         so the cheap-exit guard is skipped deliberately — the work is 4 rect
         reads inside a rAF, which is what the shared branch costs anyway. */
      lastP = -1;
      /* ROUND 101. `max`, not a replacement: the vh term still governs every
         viewport taller than 714px. See the W_FLOOR block above. */
      var wWin = vh * (S_IN - S_OUT);
      if (wWin < W_FLOOR) wWin = W_FLOOR;
      for (var j = 0; j < n; j++) {
        var cr = cards[j].getBoundingClientRect();
        var lj = (vh * S_IN - cr.top) / wWin;
        lj = lj < 0 ? 0 : (lj > 1 ? 1 : lj);
        var ej = easeOut(lj);
        cards[j].style.setProperty('--cd', ej.toFixed(4));
        var wj = ej >= SETTLE;
        if (wj !== settled[j]) {
          settled[j] = wj;
          if (wj) cards[j].classList.add('shopc--set');
          else cards[j].classList.remove('shopc--set');
        }
      }
      return;
    }

    var r = grid.getBoundingClientRect();
    var a = vh * P_START;
    var b = vh * P_TAIL - r.height;
    if (a - b < vh * P_FLOOR) b = a - vh * P_FLOOR;
    var p = (a - r.top) / (a - b);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    /* A card's whole travel is 34px; 0.002 of p moves it well under a
       pixel on desktop and about a pixel on a tall stacked phone grid. */
    if (Math.abs(p - lastP) < 0.002) return;
    lastP = p;

    var step = n > 1 ? (C_END - C_START) / (n - 1) : 0;
    for (var i = 0; i < n; i++) {
      var local = (p - (C_START + step * i)) / C_SPAN;
      local = local < 0 ? 0 : (local > 1 ? 1 : local);
      var e = easeOut(local);
      cards[i].style.setProperty('--cd', e.toFixed(4));
      /* Scroll-LINKED, so this runs BOTH ways: scroll back up and a
         landed card returns to the driven state and re-deals. A
         one-shot cannot do that, and the retraction probe is what
         proves the difference. */
      var want = e >= SETTLE;
      if (want !== settled[i]) {
        settled[i] = want;
        if (want) cards[i].classList.add('shopc--set');
        else cards[i].classList.remove('shopc--set');
      }
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  function enable() {
    if (live) return;
    live = true;
    lastP = -1;
    band.classList.add('shopseq--live');
    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  }

  function disable() {
    if (!live) return;
    live = false;
    band.classList.remove('shopseq--live');
    window.removeEventListener('scroll', onScroll);
    /* Round 55's rule: hand a driven surface back WHOLE. A frozen
       mid-deal `--cd` must never outlive the driver. */
    cards.forEach(function (c, i) {
      c.style.removeProperty('--cd');
      c.classList.remove('shopc--set');
      settled[i] = false;
    });
    grid.classList.add('in');
  }

  if (isLive()) enable();

  /* ROUND 180 — one handler, two events. `resize` and the preference `change`
     ask the identical question ("should this driver be running right now?") and
     must not answer it with two different code paths that can drift apart. */
  function reassess() {
    if (isLive()) { enable(); lastP = -1; onScroll(); }
    else disable();
  }

  window.addEventListener('resize', reassess, { passive: true });
  if (rmq) {
    if (rmq.addEventListener) rmq.addEventListener('change', reassess);
    else if (rmq.addListener) rmq.addListener(reassess);   /* Safari < 14 */
  }
})();

/* ============================================================
   ROUND 140 - axis 1, backlog 119. THE COMPARISON TABLE'S SCROLL AFFORDANCE.

   NOT a sixth scroll-driven system. It is not tied to window scroll at all - it
   reads the TABLE's own `scrollLeft` and writes two 0/1 flags. It never touches
   `--ap`, `--rp`/`--pp`/`--np`, `--gp`/`--tp`, `--rw`/`--cp`, `--cd`, `[data-seq]`,
   the header, or the round-76 proof ledger whose markup it sits inside.

   MEASURED DEFECT (captures/round-140-cmp-BEFORE.json): 248px / 44.3% of the
   table is off the right edge at 360px, 218px / 38.9% at 390px, and
   `document.scrollWidth == innerWidth` at both - so the PAGE is fine and the
   table is doing exactly what `overflow-x:auto` was asked to do. What was
   missing was any signal that it scrolls.

   THE FLAGS, and why they are flags and not a continuous ramp:
     --cmp-fr  1 while there is content still hidden to the RIGHT, else 0
     --cmp-fl  1 while the visitor has scrolled away from the LEFT edge, else 0
   A continuous ramp would make the fade grow and shrink under the thumb, which
   reads as a rendering fault on a surface the visitor is trying to READ. The
   question a fade answers is binary - "is there more?" - so the answer is
   binary. The one softening is the 2px CSS transition on the hint, not on the
   mask.

   WRITTEN ON THE SECTION, NOT ON THE TABLE. Custom properties inherit, and the
   hint is a SIBLING of the table, not a child - `.cmpx + .cmp{margin-top:18px}`
   is a round-76 adjacency contract and nothing may be inserted between the
   ledger and the table. Setting the flags on the band feeds both.

   THE END-OF-SCROLL FALSIFIER: `EPS = 1.5`. Browsers land fractional
   `scrollLeft` at the extremes (zoom, device pixel ratio, sub-pixel gutters), so
   an exact `>= maxScroll` test leaves a permanent 0.4px sliver of fade at the
   right end - which is the exact defect this fix exists to avoid, reintroduced
   as a rounding artefact. 1.5px is under one CSS pixel of visible fade and above
   every fractional residue observed.

   NO-JS / BAIL-OUT STATE: both flags stay unset, `var(--cmp-fr,0)` resolves to
   0, the mask collapses to a no-op and the hint sits at `opacity:0`. The table
   is then exactly the surface it was for 139 rounds. Round 76's rule holds - the
   failure mode is "round 139", never a permanently half-faded table.
   ============================================================ */
(function () {
  'use strict';
  var box = document.querySelector('[data-cmp-scroller]');
  if (!box) return;
  /* The band is what both the mask and the hint inherit from. Fall back to the
     table's own parent rather than bailing - a missing `[data-proofseq]` should
     cost the hint's fade, not the whole affordance. */
  var band = box.closest('[data-proofseq]') || box.parentElement;
  if (!band) return;

  var EPS = 1.5;
  var lastR = -1, lastL = -1, ticking = false;

  function paint() {
    ticking = false;
    var max = box.scrollWidth - box.clientWidth;
    /* max <= EPS means nothing is hidden at this width - tablet and desktop,
       where clientWidth (720, 1192) already exceeds the table's 560px
       min-width. Both flags go to 0 and the mask is a no-op. The fix must not
       be visible anywhere it is not needed. */
    var r = (max > EPS && box.scrollLeft < max - EPS) ? 1 : 0;
    var l = (max > EPS && box.scrollLeft > EPS) ? 1 : 0;
    if (r === lastR && l === lastL) return;
    lastR = r; lastL = l;
    band.style.setProperty('--cmp-fr', r);
    band.style.setProperty('--cmp-fl', l);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  box.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { lastR = -1; onScroll(); },
                          { passive: true });
  /* Fonts land after first paint and the table's min-width is 560px of TEXT, so
     scrollWidth is not final at DOMContentLoaded. Re-read once the web fonts
     have settled rather than trusting the first frame. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { lastR = -1; paint(); });
  }
  paint();
})();

/* ============================================================
   ROUND 141 - THE PROOF LEDGER PILL GETS OUT OF THE HEADERS' WAY
   (axis 3, backlog 120)

   SIXTH scroll-driven surface, and the smallest of them. It owns ONE custom
   property, `--cmpx-vis`, written on `[data-proofseq]` (the band), and it reads
   nothing any other driver writes. It never touches `--cp`/`--rw` (round 76),
   `--cmp-fr`/`--cmp-fl` (round 140), `--ap`, `--gp`/`--tp` or `[data-seq]`.

   MEASURED DEFECT (`captures/round-141-pill-BEFORE.json`, 10px step, 33 stops
   per width, three phone widths): the round-76 pill, docked at `top:83px`, and
   the comparison table's `thead` occupy the same 53.6px of screen for a 53.6px
   band of scroll - 66.27% of the header row gone, at m360, m390 and m414 alike,
   at the exact scroll position where the table's first rows are being read. On a
   comparison table the headers ARE the frame; losing two thirds of them while
   reading row 1 is a comprehension defect, not a cosmetic one.

   WHY A FADE AND NOT A MOVE - the full argument is in np.css above this rule, but
   the short version is that it was TRIED: the first push of this round lifted the
   pill above the thead, measured 0.0px of overlap for the entire crossing, and
   then put 53.6px of overlap back 60px further down the page on the way home
   (`captures/round-141-pill-AFTER-lift.json`). An 80.9px header moving at 1px per
   px of scroll cannot be dodged continuously by a 53.6px pill. A gap-driven fade
   has no such constraint: wherever the two boxes intersect the pill is already at
   opacity 0, so there is no geometry left to get wrong.

   THE FUNCTION: `gap` is the distance between the pill's DOCKED box and the live
   thead box, positive when they are clear of each other and negative when they
   overlap. Visibility is that gap ramped over FADE px.

     gapBelow = theadTop    - (dock + pillH)     thead is below the docked pill
     gapAbove = dock        - theadBottom        thead is above it
     vis      = clamp(max(gapBelow, gapAbove) / FADE, 0, 1)

   DOCKED, not live: measuring the gap from the pill's rendered rect would feed
   the driver's own output back into its input on the next frame.

   NO TRANSITION, EVER (backlog 21) - `filter` is not in `.rv`'s transition list,
   so this is instant for free. And no bail-out can leave the pill invisible:
   every early return writes 1.
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-proofseq]');
  if (!band) return;
  var pill = band.querySelector('[data-proof-ledger]');
  var thead = band.querySelector('[data-proof-table] thead');
  if (!pill || !thead) return;

  var FADE = 44;               /* px of scroll the ramp is spread over, each side */
  var last = -1, ticking = false;

  function write(v) {
    var n = Math.round(v * 1000) / 1000;
    if (n === last) return;
    last = n;
    band.style.setProperty('--cmpx-vis', n);
  }

  function paint() {
    ticking = false;
    var cs = window.getComputedStyle(pill);
    /* Not sticky = tablet/desktop, or the round-76 driver never went live. There
       is nothing pinned over the headers, so there is nothing to get out of. */
    if (cs.position !== 'sticky') { write(1); return; }
    var dock = parseFloat(cs.top);
    if (!isFinite(dock)) { write(1); return; }

    /* offsetHeight is LAYOUT, so it is immune to the filter this driver writes
       and to the reveal's transform. The docked box is [dock, dock + pillH]. */
    var pillH = pill.offsetHeight;
    var t = thead.getBoundingClientRect();
    if (!pillH || !t.height) { write(1); return; }

    var gap = Math.max(t.top - (dock + pillH), dock - t.bottom);
    var vis = gap / FADE;
    write(vis < 0 ? 0 : (vis > 1 ? 1 : vis));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { last = -1; onScroll(); },
                          { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { last = -1; paint(); });
  }
  paint();
})();

/* ============================================================
   ROUND 194 — VISUAL CRAFT (axis 1), backlog 205. The #pathway phone disclosure.

   THE NUMBER: the phone page is 17,716px against gruns' 10,535px desktop page.
   `#pathway` is 3,208px of it, the fattest section on the phone, and 2,670px of
   THAT is one column of six `.ing` cards. Both obvious fixes — a horizontal card
   with the photo on the left, a shorter photo aspect on the phone — are photo
   frame re-shapes and are barred by the photography pause. `.ing-img`'s 213px
   was checked and IS the frame (`aspect-ratio:16/10`, 342/1.6 = 213.75), so it
   is not touched either. What is left, and what this does, is show fewer ROWS.

   WHAT IT IS NOT: it is not a carousel and it is not a `max-height` clip. A
   `max-height` clip would leave all six cards laid out, so the round-71 driver
   would go on counting doses at scroll positions that no longer correspond to
   anything on screen. `display:none` removes them from layout, which is both
   where the 1,754px comes from AND what makes the driver's population honest —
   see the `vis[]` patch in the round-71 block above.

   PROGRESSIVE ENHANCEMENT, IN BOTH DIRECTIONS. Nothing is collapsed until this
   runs, and `.path-more` is `display:none` until this adds `pathmore--on`. With
   JS dead the visitor gets round 70's six cards and no button. With JS alive but
   the CSS somehow stale, the SELF-CHECK below catches it: after adding the class
   it counts how many cards are actually still rendered, and if that is not the
   `data-path-shown` the template declared, it takes the class straight back off
   and leaves the section expanded. A disclosure that cannot prove it disclosed
   the right amount does not get to run.

   ONE-WAY. Once opened it stays open for the page's life, including across a
   rotate back to portrait. Re-collapsing content a visitor deliberately opened
   is the one thing a disclosure must never do.

   IT DOES NOT CALL INTO THE ROUND-71 DRIVER. It dispatches a `resize`, which is
   the event that driver (and every other driver in this file) already treats as
   "your cached geometry is void". No new coupling, no exported handle, and the
   failure mode if the driver is absent is a page that simply got taller.
   ============================================================ */
(function () {
  'use strict';
  var band = document.querySelector('[data-pathseq]');
  if (!band) return;
  var grid = band.querySelector('[data-path-grid]');
  var btn = band.querySelector('[data-path-more]');
  if (!grid || !btn) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-path-card]'));
  var shown = parseInt(grid.getAttribute('data-path-shown'), 10) || 0;
  /* Nothing to disclose, or a template that asked for more cards than it has:
     leave the section exactly as round 70 built it. */
  if (!shown || cards.length <= shown) return;

  var mq = window.matchMedia('(max-width:560px)');
  var opened = false;
  var broken = false;

  function rendered() {
    var n = 0;
    for (var i = 0; i < cards.length; i++) if (cards[i].offsetParent !== null) n++;
    return n;
  }

  function collapse() {
    grid.classList.add('is-collapsed');
    /* THE SELF-CHECK. One forced layout, once, at first collapse only. */
    if (rendered() !== shown) {
      grid.classList.remove('is-collapsed');
      broken = true;
      return false;
    }
    band.classList.add('pathmore--on');
    btn.setAttribute('aria-expanded', 'false');
    return true;
  }

  function expand(focusIt) {
    grid.classList.remove('is-collapsed');
    btn.setAttribute('aria-expanded', 'true');
    if (focusIt) {
      /* The button removes itself, so focus would land on `body` and a keyboard
         visitor would lose their place four cards up the page. Hand it to the
         first card that just appeared instead. `tabindex="-1"` is set here and
         not in the template: it is only meaningful once this script exists. */
      var first = cards[shown];
      if (first) {
        first.setAttribute('tabindex', '-1');
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }
    }
    /* Every cached rect in this file is now wrong — the grid just grew 1,754px.
       `resize` is the contract those drivers already publish for exactly this. */
    window.dispatchEvent(new Event('resize'));
  }

  function apply() {
    if (opened || broken) return;
    if (mq.matches) collapse();
    else if (grid.classList.contains('is-collapsed')) {
      grid.classList.remove('is-collapsed');
      band.classList.remove('pathmore--on');
    }
  }

  btn.addEventListener('click', function () {
    if (opened) return;
    opened = true;
    expand(true);
  });

  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();

/* ROUND 202 — the one line that makes the press system exist on an iPhone.
   WebKit does not apply `:active` to a non-anchor, non-button element unless a
   touch listener is registered on the document. `.plan` is a <label>, `.acc-q`
   is a <summary>, `.ing`/`.pat`/`.card`/`.bm-th` are divs — every one of them
   would keep its round-202 press rule and never fire it without this.
   Passive and empty on purpose: it registers intent to WebKit and does no work,
   so it cannot cost a frame and cannot block a scroll. */
document.addEventListener('touchstart', function () {}, { passive: true });
